import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Table, Form, InputGroup, Spinner, Badge, NavDropdown, Nav, Card, Modal, ProgressBar } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select';

const getApiUrl = () => localStorage.getItem('apiUrl') || 'http://localhost:8000';
const fmt = (n) => (n || 0).toLocaleString('id-ID');

const KasBendahara = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [menus, setMenus] = useState([]);
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [time, setTime] = useState({ date: '', clock: '' });

  const [listKas, setListKas] = useState([]);
  const [listRekening, setListRekening] = useState([]);
  const [selectedKdBank, setSelectedKdBank] = useState('');
  
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  
  
  const [showModalTerima, setShowModalTerima] = useState(false);
  const [jenisPenerimaan, setJenisPenerimaan] = useState('0');
  const [listPenerimaan, setListPenerimaan] = useState([]);
  
  
  
  const [alertState, setAlertState] = useState({ show: false, message: '', variant: 'warning' });
  const showAlert = (message, variant = 'warning') => setAlertState({ show: true, message, variant });

  const [pdfProgress, setPdfProgress] = useState(0);

  const [showModalLapKas, setShowModalLapKas] = useState(false);
  const [lapJenis, setLapJenis] = useState('all'); // 'all' or 'per'
  const [lapKdBank, setLapKdBank] = useState('');
  
  // Initialize to today
  const [lapPeriode1, setLapPeriode1] = useState(new Date().toISOString().split('T')[0]);
  const [lapPeriode2, setLapPeriode2] = useState(new Date().toISOString().split('T')[0]);
  
  const handleCetakLaporanKas = async () => {
    if (lapJenis === 'per' && !lapKdBank) {
      showAlert("Pilih Kode Rekening terlebih dahulu!", "warning");
      return;
    }
    
    try {
      const token = localStorage.getItem('token');
      // format date from YYYY-MM-DD to DD/MM/YYYY
      const formatTgl = (d) => {
          const [yyyy, mm, dd] = d.split('-');
          return `${dd}/${mm}/${yyyy}`;
      };
      
      const payload = {
        jenis: lapJenis,
        kdbank: lapKdBank,
        periode1: formatTgl(lapPeriode1),
        periode2: formatTgl(lapPeriode2)
      };

      const res = await fetch(`${getApiUrl()}/cetak_laporan_buku_kas?token=${encodeURIComponent(token)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!res.ok) {
          throw new Error("Gagal mengunduh laporan");
      }
      
      const blob = await res.blob();
      if (blob.size === 0) {
          showAlert("Data kosong", "info");
          return;
      }
      
      const fileURL = URL.createObjectURL(blob);
      
      // Buka Modal PDF yang sudah kita buat sebelumnya
      setPdfUrl(fileURL);
      setShowModalPdf(true);
      setShowModalLapKas(false);
      
    } catch (err) {
      showAlert("Terjadi kesalahan: " + err.message, "danger");
    }
  };
const [showModalPdf, setShowModalPdf] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');
const [showModalPosting, setShowModalPosting] = useState(false);
  const [selectedSetoran, setSelectedSetoran] = useState(null);
  const [postingRows, setPostingRows] = useState([{ norek: '', nosetoran: '', tanggal: '', nilai: 0 }]);
  const [keteranganPosting, setKeteranganPosting] = useState('');

  // State Laporan Kartu & Buku Piutang
  const [showModalKartuBukuPiutang, setShowModalKartuBukuPiutang] = useState(false);
  const [lpJenisLaporan, setLpJenisLaporan] = useState('kartu'); // 'kartu' or 'buku'
  const [lpJenisPiutang, setLpJenisPiutang] = useState('1'); // '1': Perusahaan, '2': Dokter, '3': Karyawan
  const [lpSemuaDebitor, setLpSemuaDebitor] = useState(true);
  const [lpKdDebitor, setLpKdDebitor] = useState('');
  const [lpNmDebitor, setLpNmDebitor] = useState('');
  const [lpDebitorList, setLpDebitorList] = useState([]);
  const [lpPeriode1, setLpPeriode1] = useState(new Date().toISOString().split('T')[0]);
  const [lpPeriode2, setLpPeriode2] = useState(new Date().toISOString().split('T')[0]);
  const [lpBulan, setLpBulan] = useState(String(new Date().getMonth() + 1).padStart(2, '0'));
  const [lpTahun, setLpTahun] = useState(String(new Date().getFullYear()));
  const [lpIsProcessing, setLpIsProcessing] = useState(false);
  const [lpProgress, setLpProgress] = useState(0);
  const [lpStatusText, setLpStatusText] = useState('');

  // State Laporan Harian Kasir (Tunai & Piutang)
  const [showModalKasirHarian, setShowModalKasirHarian] = useState(false);
  const [khJenis, setKhJenis] = useState('TUNAI'); // 'TUNAI' or 'PIUTANG'
  const [khPeriode1, setKhPeriode1] = useState(new Date().toISOString().split('T')[0]);
  const [khPeriode2, setKhPeriode2] = useState(new Date().toISOString().split('T')[0]);
  const [khIsProcessing, setKhIsProcessing] = useState(false);
  const [khProgress, setKhProgress] = useState(0);
  const [khStatusText, setKhStatusText] = useState('');

  // State Modal Penerimaan Non Setoran Kasir
  const [showModalPenerimaanNonKasir, setShowModalPenerimaanNonKasir] = useState(false);
  const [noPenerimaan, setNoPenerimaan] = useState('');
  const [jenisTerima, setJenisTerima] = useState(1); // 1: Pelunasan Piutang, 2: Penerimaan Lain, 3: Posting titipan
  const [tglTransaksi, setTglTransaksi] = useState(new Date().toISOString().split('T')[0]);
  const [noRekening, setNoRekening] = useState('');
  const [kdBankPenerimaan, setKdBankPenerimaan] = useState('');
  const [nmBankPenerimaan, setNmBankPenerimaan] = useState('');
  const [tglBukuBank, setTglBukuBank] = useState(new Date().toISOString().split('T')[0]);
  const [namaPengirim, setNamaPengirim] = useState('');
  const [typePenjamin, setTypePenjamin] = useState(1); // 1: Perusahaan, 2: Dokter, 3: Karyawan
  const [kdPrs, setKdPrs] = useState('');
  const [nmPrs, setNmPrs] = useState('');
  const [nilaiPenerimaan, setNilaiPenerimaan] = useState(0);
  const [uraianPenerimaan, setUraianPenerimaan] = useState('');
  const [noBuktiNext, setNoBuktiNext] = useState('');
  const [isProcessingPenerimaan, setIsProcessingPenerimaan] = useState(false);

  // State Lookup Penjamin
  const [showModalLookupPenjamin, setShowModalLookupPenjamin] = useState(false);
  const [searchLookupPenjamin, setSearchLookupPenjamin] = useState('');
  const [listLookupPenjamin, setListLookupPenjamin] = useState([]);
  const [isLoadingLookupPenjamin, setIsLoadingLookupPenjamin] = useState(false);

  // State Modal Cetak Nota Penerimaan
  const [showModalNotaPenerimaan, setShowModalNotaPenerimaan] = useState(false);
  const [notaPenerimaanText, setNotaPenerimaanText] = useState('');

  // State Modal Tanggal Otorisasi Angsuran (Print Ulang Penerimaan)
  const [showModalOtorisasiAngsuran, setShowModalOtorisasiAngsuran] = useState(false);
  const [tglOtorisasiAngsuran, setTglOtorisasiAngsuran] = useState(new Date().toISOString().split('T')[0]);
  const [isLoadingCetakTitip, setIsLoadingCetakTitip] = useState(false);

  // State Modal View PDF Titip Ulang (in-app preview tanpa buka page baru)
  const [showModalPdfTitip, setShowModalPdfTitip] = useState(false);
  const [pdfTitipUrl, setPdfTitipUrl] = useState('');
  const [pdfTitipTitle, setPdfTitipTitle] = useState('');

  const handleProsesKasirHarianExcel = async () => {
    setKhIsProcessing(true);
    setKhProgress(20);
    setKhStatusText(`Memproses Export Excel Kasir Harian (${khJenis})...`);

    try {
      const token = localStorage.getItem('token');
      const formatTgl = (d) => {
        if (!d) return '';
        const [yyyy, mm, dd] = d.split('-');
        return `${dd}/${mm}/${yyyy}`;
      };

      const payload = {
        jenis: khJenis,
        periode1: formatTgl(khPeriode1),
        periode2: formatTgl(khPeriode2)
      };

      setKhProgress(50);
      const res = await fetch(`${getApiUrl()}/laporan_kasir_harian_excel?token=${encodeURIComponent(token)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      setKhProgress(85);

      if (!res.ok) {
        let errMsg = "Gagal memproses excel";
        try {
          const errJson = await res.json();
          errMsg = errJson.message || errMsg;
        } catch (e) {}
        throw new Error(errMsg);
      }

      const blob = await res.blob();
      if (blob.size === 0) {
        throw new Error("Hasil data kosong");
      }

      setKhProgress(100);
      setKhStatusText("Proses selesai. Mengunduh file Excel...");

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Laporan_Kasir_${khJenis}_${khPeriode1}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      setShowModalKasirHarian(false);
    } catch (err) {
      setKhStatusText(`Error: ${err.message}`);
      showAlert("Terjadi kesalahan: " + err.message, "danger");
    } finally {
      setKhIsProcessing(false);
    }
  };

  const handleProsesKasirHarian = async () => {
    setKhIsProcessing(true);
    setKhProgress(20);
    setKhStatusText(`Memproses Laporan Kasir Harian (${khJenis})...`);

    try {
      const token = localStorage.getItem('token');
      const formatTgl = (d) => {
        if (!d) return '';
        const [yyyy, mm, dd] = d.split('-');
        return `${dd}/${mm}/${yyyy}`;
      };

      const payload = {
        jenis: khJenis,
        periode1: formatTgl(khPeriode1),
        periode2: formatTgl(khPeriode2)
      };

      setKhProgress(50);
      const res = await fetch(`${getApiUrl()}/laporan_kasir_harian_pdf?token=${encodeURIComponent(token)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      setKhProgress(85);

      if (!res.ok) {
        let errMsg = "Gagal memproses laporan";
        try {
          const errJson = await res.json();
          errMsg = errJson.message || errMsg;
        } catch (e) {}
        throw new Error(errMsg);
      }

      const blob = await res.blob();
      if (blob.size === 0) {
        throw new Error("Hasil data kosong");
      }

      setKhProgress(100);
      setKhStatusText("Proses cetak selesai. Dokumen ditampilkan di layar.");

      const fileURL = URL.createObjectURL(blob);
      setPdfUrl(fileURL);
      setShowModalPdf(true);
      setShowModalKasirHarian(false);
    } catch (err) {
      setKhStatusText(`Error: ${err.message}`);
      showAlert("Terjadi kesalahan: " + err.message, "danger");
    } finally {
      setKhIsProcessing(false);
    }
  };

  const fetchDebitorList = async (typeVal = '1') => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${getApiUrl()}/show_penjamin_by_type?token=${encodeURIComponent(token)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          type_jamin: typeVal || '1',
          search: ''
        })
      });
      const data = await res.json();
      const list = data.list_penjamin || data.data || data.list_perusahaan || [];
      if (Array.isArray(list)) {
        setLpDebitorList(list);
      } else {
        setLpDebitorList([]);
      }
    } catch (err) {
      console.error("Error fetching debitor list from show_penjamin_by_type:", err);
      setLpDebitorList([]);
    }
  };

  useEffect(() => {
    if (showModalKartuBukuPiutang) {
      fetchDebitorList(lpJenisPiutang || '1');
    }
  }, [showModalKartuBukuPiutang, lpJenisPiutang]);

  const handleSelectDebitor = (opt) => {
    if (opt) {
      setLpKdDebitor(opt.value);
      setLpNmDebitor(opt.label);
    } else {
      setLpKdDebitor('');
      setLpNmDebitor('');
    }
  };

  const handleChangeKdDebitor = (val) => {
    setLpKdDebitor(val);
    const found = lpDebitorList.find(d => d.kode.toLowerCase() === val.trim().toLowerCase());
    if (found) {
      setLpNmDebitor(found.nama);
    } else {
      setLpNmDebitor('');
    }
  };

  const handleProsesKartuBukuPiutang = async () => {
    if (lpJenisLaporan === 'kartu') {
      if (!lpSemuaDebitor && !lpKdDebitor) {
        showAlert("Pilih Kode Debitor terlebih dahulu atau centang SEMUA!", "warning");
        return;
      }
    }

    setLpIsProcessing(true);
    setLpProgress(20);
    setLpStatusText(lpJenisLaporan === 'kartu' ? `Memproses Laporan Kartu Piutang ${lpSemuaDebitor ? '(Semua Debitor)' : (lpNmDebitor || lpKdDebitor)}...` : "Memproses Laporan Buku Piutang...");

    try {
      const token = localStorage.getItem('token');
      const formatTgl = (d) => {
        if (!d) return '';
        const [yyyy, mm, dd] = d.split('-');
        return `${dd}/${mm}/${yyyy}`;
      };

      let endpoint = '';
      let payload = {};

      if (lpJenisLaporan === 'kartu') {
        endpoint = `${getApiUrl()}/laporan_kartu_piutang?token=${encodeURIComponent(token)}`;
        payload = {
          type: lpJenisPiutang,
          semua: lpSemuaDebitor,
          kd_prs: lpKdDebitor,
          periode1: formatTgl(lpPeriode1),
          periode2: formatTgl(lpPeriode2)
        };
      } else {
        endpoint = `${getApiUrl()}/cetak_laporan_buku_piutang?token=${encodeURIComponent(token)}`;
        payload = {
          type: lpJenisPiutang,
          bulan: lpBulan,
          tahun: lpTahun
        };
      }

      setLpProgress(50);

      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      setLpProgress(85);

      if (!res.ok) {
        let errMsg = "Gagal memproses laporan";
        try {
          const errJson = await res.json();
          errMsg = errJson.message || errMsg;
        } catch (e) {}
        throw new Error(errMsg);
      }

      const blob = await res.blob();
      if (blob.size === 0) {
        throw new Error("Hasil data kosong");
      }

      setLpProgress(100);
      setLpStatusText("Proses cetak selesai. Dokumen ditampilkan di layar.");

      const fileURL = URL.createObjectURL(blob);
      setPdfUrl(fileURL);
      setShowModalPdf(true);
    } catch (err) {
      setLpStatusText(`Error: ${err.message}`);
      showAlert("Terjadi kesalahan: " + err.message, "danger");
    } finally {
      setLpIsProcessing(false);
    }
  };


  const handleOpenPosting = (item) => {
    setSelectedSetoran(item);
    const itemNilai = jenisPenerimaan === '0' ? (item.nilai || 0) : (item.bank || 0);
    setPostingRows([{ norek: '', nosetoran: '', tanggal: item.tanggal || '', nilai: itemNilai }]);
    setKeteranganPosting('');
    setShowModalPosting(true);
  };

  
  
  const handleRincianSementara = async () => {
    if (!selectedKdBank) {
      showAlert("Pilih Bank terlebih dahulu!", "warning");
      return;
    }

    // Tampilkan modal dan mulai progress bar
    setShowModalPdf(true);
    setPdfUrl('');
    setPdfProgress(10);
    
    // Interval untuk fake progress bar
    const progressInterval = setInterval(() => {
      setPdfProgress(prev => (prev < 85 ? prev + Math.floor(Math.random() * 10) + 5 : prev));
    }, 400);

    try {
      const bank = listRekening.find(r => r.kode === selectedKdBank);
      const nmbank = bank ? bank.nm_bank : '';
      const payload = {
        kdbank: selectedKdBank,
        nmbank: nmbank
      };
      const token = localStorage.getItem('token');

      const res = await fetch(`${getApiUrl()}/laporankas_sementara?token=${encodeURIComponent(token)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!res.ok) {
        throw new Error('Gagal mencetak laporan atau server bermasalah.');
      }

      const blob = await res.blob();
      const fileURL = URL.createObjectURL(blob);
      
      clearInterval(progressInterval);
      setPdfProgress(100);
      
      // Beri sedikit waktu agar bar mencapai 100% sebelum render iframe
      setTimeout(() => {
        setPdfUrl(fileURL);
      }, 400);

    } catch (err) {
      clearInterval(progressInterval);
      setShowModalPdf(false);
      showAlert("Terjadi kesalahan: " + err.message, "danger");
    }
  };
const handleProsesPosting = async () => {
    try {
      const token = localStorage.getItem('token');
      const rows = postingRows.map(r => {
        const rek = listRekening.find(item => (item.no_rekening || item.kode) === r.norek);
        return {
          no_rekening: r.norek,
          kd_bank: rek ? rek.kode : '',
          no_setoran: r.nosetoran,
          tgl_setor: r.tanggal,
          nilai: r.nilai
        };
      });

      const payload = {
        kode_bpu: selectedSetoran?.no_bpu,
        rows: rows
      };

      const res = await fetch(`${getApiUrl()}/simpan_setoran?token=${encodeURIComponent(token)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const json = await res.json();
      if (json.status === 'success') {
        showAlert(json.message, "success");
        setShowModalPosting(false);
      } else {
        showAlert("Error: " + json.message, "danger");
      }
    } catch (err) {
      showAlert("Terjadi kesalahan koneksi", "danger");
    }
  };
const handleAddPostingRow = () => {
    setPostingRows([...postingRows, { norek: '', nosetoran: '', tanggal: '', nilai: 0 }]);
  };

  const handlePostingChange = (index, field, value) => {
    const newRows = [...postingRows];
    newRows[index][field] = value;
    setPostingRows(newRows);
  };
const [isPenerimaanLoading, setIsPenerimaanLoading] = useState(false);

  useEffect(() => {
    if (showModalTerima) {
      fetchPenerimaan();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModalTerima, jenisPenerimaan]);

  const fetchPenerimaan = async () => {
    setIsPenerimaanLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${getApiUrl()}/show_penerimaan?jnspenerimaan=${jenisPenerimaan}&token=${encodeURIComponent(token)}`);
      const json = await res.json();
      setListPenerimaan(Array.isArray(json.list_penerimaan) ? json.list_penerimaan : []);
    } catch (err) {
      setListPenerimaan([]);
    } finally {
      setIsPenerimaanLoading(false);
    }
  };

  const totalPenerimaan = listPenerimaan.reduce((sum, item) => sum + (jenisPenerimaan === '0' ? (item.nilai || 0) : (item.bank || 0)), 0);
const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    const savedMenu = localStorage.getItem('mainmenu');
    if (savedMenu) {
      try { setMenus(JSON.parse(savedMenu)); } catch (e) { setMenus([]); }
    }
    const updateTime = () => {
      const now = new Date();
      const dd = String(now.getDate()).padStart(2, '0');
      const mm = String(now.getMonth() + 1).padStart(2, '0');
      const hh = String(now.getHours()).padStart(2, '0');
      const mi = String(now.getMinutes()).padStart(2, '0');
      const ss = String(now.getSeconds()).padStart(2, '0');
      setTime({ date: `${dd}/${mm}/${now.getFullYear()}`, clock: `${hh}:${mi}:${ss}` });
    };
    updateTime();
    const timer = setInterval(updateTime, 1000);
    return () => clearInterval(timer);
  }, []);

  const fetchRekening = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${getApiUrl()}/show_rekening?token=${encodeURIComponent(token)}`);
      const json = await res.json();
      if (json && json.list_rekening) {
        setListRekening(json.list_rekening);
      } else if (Array.isArray(json)) {
        setListRekening(json);
      }
    } catch (err) {
      console.error("Gagal load show_rekening", err);
    }
  };

  useEffect(() => {
    fetchRekening();
  }, []);

  const fetchKasBendahara = async () => {
    if (!selectedKdBank) return;
    setIsLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${getApiUrl()}/show_kasbendahara?kdbank=${encodeURIComponent(selectedKdBank)}&token=${encodeURIComponent(token)}`);
      const json = await res.json();
      setListKas(Array.isArray(json.kas_bendahara) ? json.kas_bendahara : []);
    } catch (err) { 
      setListKas([]); 
    } finally { 
      setIsLoading(false); 
    }
  };

  useEffect(() => {
    if (selectedKdBank) {
      fetchKasBendahara();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedKdBank]);

  const filteredList = listKas.filter(item =>
    (item.keterangan || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
    (item.no_nota || '').toLowerCase().includes(searchQuery.toLowerCase())
  );

  const totalMasuk = filteredList.reduce((a, c) => a + (c.tunai || 0) + (c.bank || 0) + (c.dokumen || 0), 0);
  const totalKeluar = filteredList.reduce((a, c) => a + (c.keluar || 0), 0);
  const saldo = totalMasuk - totalKeluar;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredList.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredList.length / itemsPerPage);

  useEffect(() => { setCurrentPage(1); }, [searchQuery, listKas]);

  // ─────────────────────────────────────────────────────────────────
  // LOGIKA PENERIMAAN NON SETORAN KASIR (SESUAI GAMBAS)
  // ─────────────────────────────────────────────────────────────────
  const fetchNextNomorPenerimaan = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${getApiUrl()}/get_nomor_penerimaan_bendahara?token=${encodeURIComponent(token)}`);
      const data = await res.json();
      if (data && (data.no_bukti_preview || data.no_bukti)) {
        setNoBuktiNext(data.no_bukti_preview || data.no_bukti);
      }
    } catch (e) {
      console.error("Gagal load nomor penerimaan", e);
    }
  };

  const handleOpenPenerimaanNonKasir = () => {
    setNoPenerimaan('');
    setJenisTerima(1);
    const today = new Date().toISOString().split('T')[0];
    setTglTransaksi(today);
    setTglBukuBank(today);
    if (listRekening && listRekening.length > 0) {
      const defaultRek = listRekening[0];
      setNoRekening(defaultRek.no_rekening || defaultRek.kode || '');
      setKdBankPenerimaan(defaultRek.kode || '');
      setNmBankPenerimaan(defaultRek.nm_bank || defaultRek.jenis_pembayaran || '');
    }
    setNamaPengirim('');
    setTypePenjamin(1);
    setKdPrs('');
    setNmPrs('');
    setNilaiPenerimaan(0);
    setUraianPenerimaan('');
    fetchNextNomorPenerimaan();
    setShowModalPenerimaanNonKasir(true);
  };

  const handleSelectRekeningPenerimaan = (e) => {
    const val = e.target.value;
    setNoRekening(val);
    const found = listRekening.find(r => (r.no_rekening || r.kode) === val);
    if (found) {
      setKdBankPenerimaan(found.kode || '');
      setNmBankPenerimaan(found.nm_bank || found.jenis_pembayaran || '');
    }
  };

  const fetchLookupPenjamin = async (tVal, qVal = '') => {
    setIsLoadingLookupPenjamin(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${getApiUrl()}/lookup_penjamin_bendahara?type=${tVal}&q=${encodeURIComponent(qVal || '')}&token=${encodeURIComponent(token)}`);
      const data = await res.json();
      if (data && Array.isArray(data.data)) {
        setListLookupPenjamin(data.data);
      } else {
        setListLookupPenjamin([]);
      }
    } catch (e) {
      console.error("Gagal load lookup penjamin", e);
      setListLookupPenjamin([]);
    } finally {
      setIsLoadingLookupPenjamin(false);
    }
  };

  const handleOpenLookupPenjamin = () => {
    setSearchLookupPenjamin('');
    fetchLookupPenjamin(typePenjamin, '');
    setShowModalLookupPenjamin(true);
  };

  const handlePilihPenjamin = (item) => {
    setKdPrs(item.kd_prs || '');
    setNmPrs(item.nm_prs || '');
    setShowModalLookupPenjamin(false);
  };

  const handleBatalPenerimaan = () => {
    setNoPenerimaan('');
    setNamaPengirim('');
    setKdPrs('');
    setNmPrs('');
    setNilaiPenerimaan(0);
    setUraianPenerimaan('');
  };

  const handleProsesPenerimaanNonKasir = async () => {
    if (!noPenerimaan.trim()) {
      showAlert("Nomor Penerimaan / Bukti Setor tidak boleh kosong!", "warning");
      return;
    }
    if (!noRekening.trim()) {
      showAlert("Nomor Rekening Bank belum dipilih!", "warning");
      return;
    }
    const valNilai = parseFloat(nilaiPenerimaan) || 0;
    if (valNilai <= 0) {
      showAlert("Nilai penerimaan harus lebih besar dari 0!", "warning");
      return;
    }

    if (!window.confirm("Simpan data penerimaan ?")) {
      return;
    }

    setIsProcessingPenerimaan(true);
    try {
      const token = localStorage.getItem('token');
      const formatTgl = (d) => {
        if (!d) return '';
        if (d.includes('/')) return d;
        const [yyyy, mm, dd] = d.split('-');
        return `${dd}/${mm}/${yyyy}`;
      };

      const payload = {
        no_penerimaan: noPenerimaan.trim(),
        jenis_terima: parseInt(jenisTerima, 10),
        tgl_transaksi: formatTgl(tglTransaksi),
        no_rekening: noRekening.trim(),
        nm_bank: nmBankPenerimaan.trim(),
        kd_bank: kdBankPenerimaan.trim() || '0000',
        tgl_buku: formatTgl(tglBukuBank),
        nama_pengirim: namaPengirim.trim(),
        type_penjamin: parseInt(typePenjamin, 10),
        kd_prs: kdPrs.trim(),
        nm_prs: nmPrs.trim(),
        nilai: valNilai,
        uraian: uraianPenerimaan.trim()
      };

      const res = await fetch(`${getApiUrl()}/proses_penerimaan_non_kasir?token=${encodeURIComponent(token)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const json = await res.json();
      if (!res.ok || json.status === 0) {
        throw new Error(json.msg || "Gagal memproses penerimaan");
      }

      showAlert(json.msg || "Data penerimaan berhasil disimpan!", "success");
      setNoBuktiNext(json.no_bukti || noBuktiNext);
      if (json.nota_text) {
        setNotaPenerimaanText(json.nota_text);
        setShowModalNotaPenerimaan(true);
      }

      if (selectedKdBank) {
        fetchKasBendahara();
      }
    } catch (err) {
      showAlert("Terjadi kesalahan: " + err.message, "danger");
    } finally {
      setIsProcessingPenerimaan(false);
    }
  };

  const handleCetakJurnalTitipUlang = async () => {
    if (!tglOtorisasiAngsuran) {
      showAlert("Silakan pilih tanggal otorisasi angsuran terlebih dahulu!", "warning");
      return;
    }

    setIsLoadingCetakTitip(true);
    try {
      const token = localStorage.getItem('token');
      let tglKirim = tglOtorisasiAngsuran;
      if (tglOtorisasiAngsuran.includes('-')) {
        const [yyyy, mm, dd] = tglOtorisasiAngsuran.split('-');
        tglKirim = `${dd}/${mm}/${yyyy}`;
      }

      const res = await fetch(`${getApiUrl()}/cetak_jurnal_titip_ulang`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          tanggal: tglKirim,
          token: token
        })
      });

      const contentType = res.headers.get('content-type') || '';
      if (contentType.includes('application/json')) {
        const data = await res.json();
        if (data.status === 0 || data.message) {
          showAlert(data.message || "Data Kosong !", "info");
          return;
        }
      }

      if (!res.ok) {
        throw new Error("Gagal mengunduh dokumen PDF");
      }

      const blob = await res.blob();
      if (blob.size === 0) {
        showAlert("Data Kosong !", "info");
        return;
      }

      if (pdfTitipUrl) {
        URL.revokeObjectURL(pdfTitipUrl);
      }

      const blobUrl = URL.createObjectURL(blob);
      setPdfTitipUrl(blobUrl);
      setPdfTitipTitle(`Laporan Jurnal Titip Ulang (${tglKirim})`);
      setShowModalOtorisasiAngsuran(false);
      setShowModalPdfTitip(true);
    } catch (err) {
      showAlert("Terjadi kesalahan: " + err.message, "danger");
    } finally {
      setIsLoadingCetakTitip(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f0f4f8', fontFamily: "'Inter', 'Segoe UI', sans-serif", display: 'flex', flexDirection: 'column' }}>
      
      {/* NAVBAR */}
      <nav className="navbar navbar-expand-lg shadow-sm" style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #0d9488 100%)', borderBottom: 'none', padding: '0 1.5rem', height: '48px' }}>
        <div className="container-fluid px-0">
          <a className="navbar-brand d-flex align-items-center gap-2" href="/" style={{ fontSize: '0.85rem', fontWeight: 700, color: '#fff' }}>
            <div style={{ background: 'rgba(255,255,255,0.1)', padding: '4px 8px', borderRadius: '6px' }}>
              <i className="bi bi-wallet2 text-warning fs-6"></i>
            </div>
            SIMRS2
          </a>
          <button className="navbar-toggler border-0" type="button" onClick={() => setIsNavOpen(!isNavOpen)}>
            <i className="bi bi-list text-white fs-5"></i>
          </button>
          <div className={`collapse navbar-collapse ${isNavOpen ? 'show' : ''}`}>
            <ul className="navbar-nav me-auto mb-1 mb-lg-0 flex-row gap-3 ms-4">
              {menus.map((item) => {
                const isActive = location.pathname.toLowerCase() === (item.lnk || '').toLowerCase();
                return (
                  <li className="nav-item" key={item.id_mn}>
                    <a href={item.lnk || '#'} className="nav-link py-1 px-2 rounded" style={{ color: isActive ? '#fff' : 'rgba(255,255,255,0.65)', fontSize: '0.75rem', fontWeight: isActive ? 600 : 500, background: isActive ? 'rgba(13,148,136,0.4)' : 'transparent' }}>
                      {item.nm_mn}
                    </a>
                  </li>
                );
              })}
            </ul>
            <div className="d-flex align-items-center gap-3">
              <span className="text-white-50 fw-medium d-none d-lg-flex align-items-center gap-2" style={{ fontSize: '0.75rem' }}>
                <i className="bi bi-clock"></i> {time.clock}
              </span>
              <Button 
                variant="outline-primary" 
                size="sm" 
                className="d-flex align-items-center gap-1 py-1 text-white border-white" 
                style={{ fontSize: '0.75rem', borderRadius: '6px', fontWeight: 600, background: 'rgba(255,255,255,0.1)' }} 
                onClick={() => navigate('/home')}
              >
                <i className="bi bi-house-door"></i>
                Home
              </Button>
            </div>
          </div>
        </div>
      </nav>

      
      <div className="container-fluid flex-grow-1 p-2 d-flex flex-column" style={{ overflow: 'hidden' }}>
        <Card className="shadow-sm border-0 flex-grow-1 d-flex flex-column" style={{ overflow: 'hidden', borderRadius: '10px' }}>
          
          {/* CARD HEADER (Standardized) */}
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2" style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0d9488 100%)', padding: '0.5rem 1rem', color: '#ffffff', fontWeight: 600, fontSize: '0.85rem' }}>
              <span className="d-flex align-items-center gap-2">
                <i className="bi bi-bank text-warning fs-5"></i> 
                <span>BUKU KAS BENDAHARA <span className="ms-2 fw-normal opacity-75" style={{ fontSize: '0.75rem' }}>| Laporan Kas Bendahara berdasarkan Bank</span></span>
              </span>
              <div className="d-flex align-items-center gap-3">
                <span className="text-white-50" style={{ fontSize: '0.75rem', fontWeight: 400 }}><i className="bi bi-calendar3 me-1"></i> {time.date}</span>
                <Button size="sm" onClick={() => navigate(-1)} style={{ background: "rgba(255,255,255,0.15)", border: "1px solid rgba(255,255,255,0.3)", color: "#fff", borderRadius: "5px", padding: "3px 10px", fontSize: "0.75rem", fontWeight: 600 }}><i className="bi bi-arrow-left me-1"></i>Kembali</Button>
              </div>
          </div>

          {/* MENU BAR (Standardized Desktop Style) */}
          <div style={{ backgroundColor: '#f8fafc', borderBottom: '1px solid #e2e8f0', padding: '0 0.75rem' }}>
            <Nav className="flex-row">
              <NavDropdown title="Otorisasi" id="nav-dropdown-otorisasi" className="fw-semibold text-dark" style={{ fontSize: '0.78rem' }}>
                <NavDropdown.Item href="#action/1.1" style={{ fontSize: '0.78rem' }}>Input Saldo Anggaran Belanja</NavDropdown.Item>
                <NavDropdown.Item href="#action/1.2" style={{ fontSize: '0.78rem' }}>Angsuran Pembayaran Piutang</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title="Transaksi" id="nav-dropdown-transaksi" className="fw-semibold text-dark" style={{ fontSize: '0.78rem' }}>
                <NavDropdown.Item href="#action/2.1" style={{ fontSize: '0.78rem' }}>Kasbon Dokter</NavDropdown.Item>
                <NavDropdown.Item href="#action/2.2" style={{ fontSize: '0.78rem' }}>Pindah Buku</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title="Laporan" id="nav-dropdown-laporan" className="fw-semibold text-dark" style={{ fontSize: '0.78rem' }}>
                <NavDropdown.Item onClick={() => setShowModalLapKas(true)} style={{ fontSize: '0.78rem', cursor: 'pointer' }}>Laporan Buku Kas Bendahara</NavDropdown.Item>
                <NavDropdown.Item onClick={() => { setShowModalKartuBukuPiutang(true); setLpProgress(0); setLpStatusText(''); }} style={{ fontSize: '0.78rem', cursor: 'pointer' }}>Laporan Buku Hutang dan Piutang</NavDropdown.Item>
                <NavDropdown.Item onClick={() => navigate('/LaporanRekapJurnalKasir')} style={{ fontSize: '0.78rem', cursor: 'pointer' }}>Laporan Rekapitulasi Jurnal Kasir</NavDropdown.Item>
                <NavDropdown.Item href="#action/3.2" style={{ fontSize: '0.78rem' }}>Laporan Buku Bank Bendahara</NavDropdown.Item>
                <NavDropdown.Item onClick={() => { setShowModalKasirHarian(true); setKhProgress(0); setKhStatusText(''); }} style={{ fontSize: '0.78rem', cursor: 'pointer' }}>Laporan Kas Harian</NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </div>

          {/* MAIN CONTENT */}
          <Card.Body className="p-2 d-flex flex-column overflow-auto" style={{ background: '#f0f4f8' }}>
            


        
        {/* TOMBOL AKSI */}
        <div className="d-flex flex-wrap gap-2 mb-1">
          <Button variant="white" className="d-flex align-items-center gap-2 border shadow-sm px-2 py-1 bg-white" style={{ borderRadius: '8px', transition: 'all 0.2s', borderColor: '#e2e8f0' }}>
            <div className="d-flex align-items-center justify-content-center rounded bg-danger-subtle text-danger" style={{ width: '28px', height: '28px' }}>
              <i className="bi bi-x-circle-fill"></i>
            </div>
            <span className="fw-bold text-dark" style={{ fontSize: '0.8rem', letterSpacing: '0.5px' }}>
              <u style={{ textUnderlineOffset: '3px' }}>T</u>UTUP KAS
            </span>
          </Button>

          <Button variant="white" className="d-flex align-items-center gap-2 border shadow-sm px-2 py-1 bg-white" style={{ borderRadius: '8px', transition: 'all 0.2s', borderColor: '#e2e8f0' }} onClick={handleRincianSementara}>
            <div className="d-flex align-items-center justify-content-center rounded bg-warning-subtle text-warning" style={{ width: '28px', height: '28px' }}>
              <i className="bi bi-clipboard2-check-fill"></i>
            </div>
            <span className="fw-bold text-dark" style={{ fontSize: '0.8rem', letterSpacing: '0.5px' }}>
              RINCIAN SEMENTARA
            </span>
          </Button>

          <Button variant="white" className="d-flex align-items-center gap-2 border shadow-sm px-2 py-1 bg-white" style={{ borderRadius: '8px', transition: 'all 0.2s', borderColor: '#e2e8f0' }} onClick={() => setShowModalTerima(true)}>
            <div className="d-flex align-items-center justify-content-center rounded bg-success-subtle text-success" style={{ width: '28px', height: '28px' }}>
              <i className="bi bi-journal-check"></i>
            </div>
            <span className="fw-bold text-dark" style={{ fontSize: '0.8rem', letterSpacing: '0.5px' }}>
              TERIMA SETORAN
            </span>
          </Button>

          <Button variant="white" className="d-flex align-items-center gap-2 border shadow-sm px-2 py-1 bg-white" style={{ borderRadius: '8px', transition: 'all 0.2s', borderColor: '#e2e8f0' }} onClick={handleOpenPenerimaanNonKasir}>
            <div className="d-flex align-items-center justify-content-center rounded" style={{ width: '28px', height: '28px', backgroundColor: '#fde68a', color: '#b45309' }}>
              <i className="bi bi-box-seam-fill"></i>
            </div>
            <span className="fw-bold text-dark" style={{ fontSize: '0.8rem', letterSpacing: '0.5px' }}>
              <u style={{ textUnderlineOffset: '3px' }}>P</u>ENERIMAAN
            </span>
          </Button>

          <Button variant="white" className="d-flex align-items-center gap-2 border shadow-sm px-2 py-1 bg-white" style={{ borderRadius: '8px', transition: 'all 0.2s', borderColor: '#e2e8f0' }}>
            <div className="d-flex align-items-center justify-content-center rounded bg-secondary-subtle text-secondary" style={{ width: '28px', height: '28px' }}>
              <i className="bi bi-arrow-90deg-left"></i>
            </div>
            <span className="fw-bold text-dark" style={{ fontSize: '0.8rem', letterSpacing: '0.5px' }}>
              KEMBALI PURS
            </span>
          </Button>

          <Button variant="white" className="d-flex align-items-center gap-2 border shadow-sm px-2 py-1 bg-white" style={{ borderRadius: '8px', transition: 'all 0.2s', borderColor: '#e2e8f0' }} onClick={() => { setSelectedKdBank(''); setSearchQuery(''); }}>
            <div className="d-flex align-items-center justify-content-center rounded bg-info-subtle text-info" style={{ width: '28px', height: '28px' }}>
              <i className="bi bi-eraser-fill"></i>
            </div>
            <span className="fw-bold text-dark" style={{ fontSize: '0.8rem', letterSpacing: '0.5px' }}>
              <u style={{ textUnderlineOffset: '3px' }}>B</u>ERSIH
            </span>
          </Button>
        </div>

        {/* SUMMARY CARDS */}

        <Row className="g-2 mb-1">
          {[
            { label: "TOTAL PEMASUKAN", value: totalMasuk, color: "#059669", bg: "linear-gradient(135deg, #d1fae5, #ecfdf5)", icon: "bi-graph-up-arrow", sub: "Tunai + Bank + Dokumen" },
            { label: "TOTAL PENGELUARAN", value: totalKeluar, color: "#dc2626", bg: "linear-gradient(135deg, #fee2e2, #fef2f2)", icon: "bi-graph-down-arrow", sub: "Seluruh Pengeluaran" },
            { label: "SALDO BERSIH", value: saldo, color: saldo >= 0 ? "#0d9488" : "#f59e0b", bg: saldo >= 0 ? "linear-gradient(135deg, #ccfbf1, #f0fdfa)" : "linear-gradient(135deg, #fef3c7, #fffbeb)", icon: "bi-wallet2", sub: "Masuk - Keluar" },
            { label: "TOTAL TRANSAKSI", value: null, count: filteredList.length, color: "#4f46e5", bg: "linear-gradient(135deg, #e0e7ff, #eef2ff)", icon: "bi-receipt-cutoff", sub: "Total Baris Data" },
          ].map((s, i) => (
            <Col xs={12} sm={6} xl={3} key={i}>
              <div className="border-0 h-100 shadow-sm" style={{ borderRadius: "12px", background: s.bg, borderLeft: `4px solid ${s.color}` }}>
                <div className="p-2 px-2 d-flex justify-content-between flex-column h-100">
                  <div className="d-flex justify-content-between align-items-start mb-1">
                    <div>
                      <div className="fw-bold mb-1" style={{ fontSize: "0.75rem", letterSpacing: "0.8px", color: s.color, opacity: 0.9 }}>{s.label}</div>
                      <div className="fw-bolder" style={{ fontSize: "1.2rem", color: s.color }}>
                        {s.count !== undefined ? s.count : `Rp ${fmt(s.value)}`}
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center shadow-sm" style={{ width: '36px', height: '36px', borderRadius: '10px', background: '#fff', color: s.color }}>
                      <i className={`bi ${s.icon} fs-5`}></i>
                    </div>
                  </div>
                  <div style={{ fontSize: "0.7rem", color: s.color, opacity: 0.75, fontWeight: 500 }}>
                    <i className="bi bi-info-circle me-1"></i>{s.sub}
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
        
        {/* FILTER CARD */}
        <div className="bg-white border rounded shadow-sm mb-2" style={{ borderColor: '#e2e8f0', borderRadius: '12px' }}>
          <div className="p-2 px-3">
            <Row className="g-2 align-items-center">
              <Col xs={12} lg={4}>
                <div className="d-flex align-items-center">
                  <div className="d-flex align-items-center px-3 text-white rounded-start h-100" style={{ fontSize: '0.75rem', fontWeight: 600, minWidth: '90px', background: '#0f766e', padding: '0.6rem 0' }}>
                    <i className="bi bi-bank2 me-2"></i> KODE BANK
                  </div>
                  <div style={{ flex: '1 1 auto' }}>
                    <Select 
                      options={listRekening.map(r => ({ value: r.kode, label: `${r.kode} - ${r.nm_bank}` }))}
                      value={listRekening.map(r => ({ value: r.kode, label: `${r.kode} - ${r.nm_bank}` })).find(o => o.value === selectedKdBank) || null}
                      onChange={(selected) => setSelectedKdBank(selected ? selected.value : '')}
                      placeholder="- Pilih / Cari Bank -"
                      styles={{ 
                        control: (base) => ({ ...base, minHeight: '34px', height: '34px', fontSize: '0.8rem', borderTopLeftRadius: 0, borderBottomLeftRadius: 0, borderColor: '#dee2e6', boxShadow: 'none' }), 
                        valueContainer: (base) => ({ ...base, padding: '0px 8px' }),
                        indicatorsContainer: (base) => ({ ...base, height: '34px' })
                      }}
                      isClearable
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} lg={5}>
                <InputGroup className="shadow-sm rounded">
                  <InputGroup.Text className="bg-white border-end-0 text-muted px-3"><i className="bi bi-search"></i></InputGroup.Text>
                  <Form.Control className="border-start-0 border-end-0 shadow-none py-1" placeholder="Cari keterangan atau No. Nota..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} style={{ fontSize: "0.85rem", fontWeight: 500 }} />
                  {searchQuery && <Button variant="outline-secondary" size="sm" className="border-start-0" onClick={() => setSearchQuery("")}><i className="bi bi-x"></i></Button>}
                </InputGroup>
              </Col>
              <Col xs={12} lg={3}>
                <Button variant="primary" size="sm" className="w-100 fw-bold d-flex align-items-center justify-content-center gap-2 rounded shadow-sm" style={{ background: 'linear-gradient(135deg, #0ea5e9, #0284c7)', border: 'none', height: '34px' }} onClick={fetchKasBendahara} disabled={isLoading || !selectedKdBank}>
                  {isLoading ? <Spinner animation="border" size="sm" /> : <><i className="bi bi-arrow-clockwise"></i> MUAT ULANG</>}
                </Button>
              </Col>
            </Row>
          </div>
        </div>

        {/* TABLE SECTION */}
        <div className="bg-white border rounded shadow-sm d-flex flex-column" style={{ borderColor: '#e2e8f0', borderRadius: '12px', minHeight: '350px' }}>
          
          <div className="d-flex align-items-center justify-content-between py-1 px-2 border-bottom">
            <div>
              <h6 className="mb-0 fw-semibold" style={{ color: '#0f172a', fontSize: '0.85rem' }}>
                <i className="bi bi-table text-primary me-2"></i>Rincian Transaksi Bendahara
              </h6>
            </div>
            <Badge bg="light" text="primary" className="border px-3 py-1 fw-semibold rounded-pill" style={{ fontSize: '0.7rem' }}>
              <i className="bi bi-database me-1"></i> {filteredList.length} Baris Data Ditemukan
            </Badge>
          </div>

          <div className="flex-grow-1" style={{ overflowX: 'auto' }}>
            <Table hover responsive className="mb-0 align-middle" size="sm" style={{ fontSize: '0.82rem', whiteSpace: 'nowrap' }}>
              <thead style={{ background: '#f8fafc' }}>
                <tr>
                  <th className="py-1 px-2 text-muted fw-semibold border-bottom text-center" style={{ fontSize: '0.7rem', width: '5%' }}>#</th>
                  <th className="py-1 text-muted fw-semibold border-bottom" style={{ fontSize: '0.7rem' }}>NO. NOTA</th>
                  <th className="py-1 text-muted fw-semibold border-bottom" style={{ fontSize: '0.7rem', width: '100%', minWidth: '300px' }}>KETERANGAN</th>
                  <th className="py-1 text-end text-muted fw-semibold border-bottom" style={{ fontSize: '0.7rem' }}>TUNAI</th>
                  <th className="py-1 text-end text-muted fw-semibold border-bottom" style={{ fontSize: '0.7rem' }}>BANK</th>
                  <th className="py-1 text-end text-muted fw-semibold border-bottom" style={{ fontSize: '0.7rem' }}>DOKUMEN</th>
                  <th className="py-1 pe-3 text-end text-muted fw-semibold border-bottom" style={{ fontSize: '0.7rem' }}>KELUAR</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan="7" className="text-center py-4">
                      <Spinner animation="border" size="sm" className="text-primary me-2" />
                      <span className="text-muted" style={{ fontSize: '0.8rem' }}>Memuat data...</span>
                    </td>
                  </tr>
                ) : currentItems.length > 0 ? (
                  currentItems.map((item, idx) => (
                    <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                      <td className="py-1 px-2 fw-medium text-muted text-center">{indexOfFirstItem + idx + 1}</td>
                      <td className="py-1 fw-semibold text-primary">{item.no_nota || "—"}</td>
                      <td className="py-1 text-dark text-wrap" style={{ minWidth: '300px' }}>{item.keterangan || "—"}</td>
                      <td className="py-1 text-end fw-semibold" style={{ color: item.tunai > 0 ? "#059669" : "#cbd5e1" }}>{item.tunai > 0 ? fmt(item.tunai) : "—"}</td>
                      <td className="py-1 text-end fw-semibold" style={{ color: item.bank > 0 ? "#059669" : "#cbd5e1" }}>{item.bank > 0 ? fmt(item.bank) : "—"}</td>
                      <td className="py-1 text-end fw-semibold" style={{ color: item.dokumen > 0 ? "#0d9488" : "#cbd5e1" }}>{item.dokumen > 0 ? fmt(item.dokumen) : "—"}</td>
                      <td className="py-1 pe-3 text-end fw-bold" style={{ color: item.keluar > 0 ? "#dc2626" : "#cbd5e1" }}>{item.keluar > 0 ? fmt(item.keluar) : "—"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center py-4 text-muted">
                      <div className="mb-1"><i className="bi bi-inbox fs-4 opacity-50"></i></div>
                      <div style={{ fontSize: '0.8rem' }}>{selectedKdBank ? "Tidak ada data transaksi bendahara." : "Silakan pilih Kode Bank terlebih dahulu."}</div>
                    </td>
                  </tr>
                )}
              </tbody>
              {filteredList.length > 0 && (
                <tfoot style={{ background: '#f8fafc' }}>
                  <tr>
                    <td colSpan="3" className="py-1 px-2 text-dark fw-bold border-top" style={{ fontSize: '0.75rem' }}>TOTAL</td>
                    <td className="py-1 text-end fw-bold text-success border-top">{fmt(filteredList.reduce((a, c) => a + (c.tunai || 0), 0))}</td>
                    <td className="py-1 text-end fw-bold text-success border-top">{fmt(filteredList.reduce((a, c) => a + (c.bank || 0), 0))}</td>
                    <td className="py-1 text-end fw-bold text-info border-top" style={{ color: '#0d9488' }}>{fmt(filteredList.reduce((a, c) => a + (c.dokumen || 0), 0))}</td>
                    <td className="py-1 pe-3 text-end fw-bold text-danger border-top">{fmt(filteredList.reduce((a, c) => a + (c.keluar || 0), 0))}</td>
                  </tr>
                  <tr style={{ background: "linear-gradient(135deg,#f0fdf4,#ecfdf5)" }}>
                    <td colSpan="3" className="py-1 px-2 text-dark fw-bold border-top" style={{ fontSize: '0.8rem' }}>SALDO AKHIR</td>
                    <td colSpan="4" className={`py-1 pe-3 text-end fw-bold border-top ${saldo >= 0 ? "text-success" : "text-danger"}`} style={{ fontSize: '1rem' }}>Rp {fmt(saldo)}</td>
                  </tr>
                </tfoot>
              )}
            </Table>
          </div>

          {/* Pagination Footer */}
          {totalPages > 1 && (
            <div className="py-1 px-2 border-top d-flex justify-content-between align-items-center mt-auto" style={{ background: '#fff' }}>
              <span className="text-muted" style={{ fontSize: '0.75rem' }}>
                Menampilkan <span className="fw-semibold text-dark">{indexOfFirstItem + 1}</span> - <span className="fw-semibold text-dark">{Math.min(indexOfLastItem, filteredList.length)}</span> dari <span className="fw-semibold text-dark">{filteredList.length}</span> hasil
              </span>
              <div className="d-flex gap-1">
                <Button variant="outline-secondary" size="sm" className="d-flex align-items-center px-2 py-0" style={{ fontSize: '0.75rem', borderColor: '#e2e8f0', color: '#475569' }} disabled={currentPage === 1} onClick={() => setCurrentPage(p => Math.max(1, p - 1))}>
                  <i className="bi bi-chevron-left"></i>
                </Button>
                {[...Array(totalPages)].map((_, i) => {
                  const page = i + 1;
                  if (page === 1 || page === totalPages || (page >= currentPage - 1 && page <= currentPage + 1)) {
                    return (
                      <Button key={page} variant={page === currentPage ? "primary" : "outline-secondary"} size="sm" className="px-2 py-0 fw-semibold" style={{ fontSize: '0.75rem', width: '26px', borderColor: page === currentPage ? '' : '#e2e8f0', color: page === currentPage ? '#fff' : '#475569' }} onClick={() => setCurrentPage(page)}>
                        {page}
                      </Button>
                    );
                  } else if (page === currentPage - 2 || page === currentPage + 2) {
                    return <span key={page} className="text-muted d-flex align-items-end px-1" style={{ fontSize: '0.75rem' }}>...</span>;
                  }
                  return null;
                })}
                <Button variant="outline-secondary" size="sm" className="d-flex align-items-center px-2 py-0" style={{ fontSize: '0.75rem', borderColor: '#e2e8f0', color: '#475569' }} disabled={currentPage === totalPages} onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}>
                  <i className="bi bi-chevron-right"></i>
                </Button>
              </div>
            </div>
          )}
        </div>

      
          </Card.Body>

        
        {/* MODAL TERIMA SETORAN */}
        <Modal show={showModalTerima} onHide={() => setShowModalTerima(false)} size="xl" backdrop="static" centered>
          <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0d9488 100%)', color: '#fff', padding: '0.5rem 1rem', borderBottom: 'none' }}>
            <Modal.Title className="d-flex align-items-center gap-2" style={{ fontSize: '0.9rem', fontWeight: 700 }}>
              <div style={{ background: 'rgba(255,255,255,0.15)', borderRadius: '7px', padding: '5px 8px' }}>
                <i className="bi bi-journal-arrow-down text-warning fs-5"></i>
              </div>
              RINCIAN SETORAN KASIR TERIMA
              <span className="text-white-50 fw-normal ms-1" style={{ fontSize: '0.72rem' }}>| {time.date} &nbsp; {time.clock}</span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-0 d-flex flex-column" style={{ height: '70vh', background: '#f0f4f8' }}>

            {/* Filter Bar */}
            <div className="d-flex align-items-center gap-3 px-3 py-2 border-bottom" style={{ background: '#fff' }}>
              <span className="fw-semibold text-muted" style={{ fontSize: '0.78rem', whiteSpace: 'nowrap' }}>
                <i className="bi bi-funnel me-1"></i>JENIS PENERIMAAN
              </span>
              <div className="d-flex gap-2">
                {[{ val: '0', label: 'Setoran Tunai', icon: 'bi-cash-stack', color: '#059669' },
                  { val: '1', label: 'Setoran EDC', icon: 'bi-credit-card-2-front', color: '#0284c7' }].map(opt => (
                  <button
                    key={opt.val}
                    type="button"
                    onClick={() => setJenisPenerimaan(opt.val)}
                    className="d-flex align-items-center gap-2 border rounded-pill fw-semibold"
                    style={{
                      fontSize: '0.8rem',
                      cursor: 'pointer',
                      padding: '4px 14px',
                      transition: 'all 0.15s',
                      background: jenisPenerimaan === opt.val ? opt.color : '#fff',
                      color: jenisPenerimaan === opt.val ? '#fff' : '#475569',
                      borderColor: jenisPenerimaan === opt.val ? opt.color : '#cbd5e1',
                    }}
                  >
                    <i className={"bi " + opt.icon}></i> {opt.label}
                  </button>
                ))}
              </div>
              <div className="ms-auto">
                <span className="badge rounded-pill" style={{ background: '#e0f2fe', color: '#0284c7', fontSize: '0.75rem', padding: '5px 10px' }}>
                  <i className="bi bi-database me-1"></i>{listPenerimaan.length} Data
                </span>
              </div>
            </div>

            {/* Table */}
            <div className="flex-grow-1 overflow-auto p-2">
              <div className="bg-white border rounded shadow-sm" style={{ borderColor: '#e2e8f0', overflow: 'hidden' }}>
                <Table hover className="mb-0 align-middle" size="sm" style={{ fontSize: '0.8rem' }}>
                  <thead>
                    <tr style={{ background: 'linear-gradient(135deg, #0f172a, #0d9488)', color: '#fff' }}>
                      <th className="py-2 px-3 fw-semibold" style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>#</th>
                      <th className="py-2 fw-semibold" style={{ fontSize: '0.7rem', letterSpacing: '0.5px', whiteSpace: 'nowrap' }}>TANGGAL</th>
                      <th className="py-2 fw-semibold" style={{ fontSize: '0.7rem', letterSpacing: '0.5px', whiteSpace: 'nowrap' }}>NO. BUKTI</th>
                      {jenisPenerimaan === '0' ? (
                        <>
                          <th className="py-2 fw-semibold" style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>NIK</th>
                          <th className="py-2 fw-semibold" style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>NAMA KASIR TERIMA</th>
                        </>
                      ) : (
                        <>
                          <th className="py-2 fw-semibold" style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>USER</th>
                          <th className="py-2 fw-semibold text-center" style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>KODE BANK</th>
                          <th className="py-2 fw-semibold text-center" style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>JENIS</th>
                        </>
                      )}
                      <th className="py-2 pe-3 fw-semibold text-end" style={{ fontSize: '0.7rem', letterSpacing: '0.5px', whiteSpace: 'nowrap' }}>NILAI [Rp]</th>
                      <th className="py-2 px-2 text-center" style={{ width: '80px', fontSize: '0.7rem' }}>AKSI</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isPenerimaanLoading ? (
                      <tr>
                        <td colSpan="8" className="text-center py-5">
                          <Spinner animation="border" size="sm" className="text-primary me-2" />
                          <span className="text-muted" style={{ fontSize: '0.8rem' }}>Memuat data setoran...</span>
                        </td>
                      </tr>
                    ) : listPenerimaan.length > 0 ? (
                      listPenerimaan.map((item, idx) => (
                        <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                          <td className="py-1 px-3 text-muted text-center fw-medium">{idx + 1}</td>
                          <td className="py-1 text-muted" style={{ whiteSpace: 'nowrap' }}>{item.tanggal || '—'}</td>
                          <td className="py-1 fw-semibold text-primary" style={{ whiteSpace: 'nowrap' }}>{item.no_bpu || '—'}</td>
                          {jenisPenerimaan === '0' ? (
                            <>
                              <td className="py-1 text-muted">{item.nik || '—'}</td>
                              <td className="py-1 fw-medium">{(item.nama || '').trim() || '—'}</td>
                              <td className="py-1 pe-3 text-end fw-bold text-success">{fmt(item.nilai)}</td>
                              <td className="py-1 text-center">
                                <Button variant="primary" size="sm" style={{ fontSize: '0.7rem', padding: '2px 8px' }} onClick={() => handleOpenPosting(item)}>Posting</Button>
                              </td>
                            </>
                          ) : (
                            <>
                              <td className="py-1 fw-medium">{item.user_id || item.nik || '—'}</td>
                              <td className="py-1 text-center">
                                {item.kd_pk && item.kd_pk.trim() ? (
                                  <span className="badge rounded-pill" style={{ background: '#e0f2fe', color: '#0284c7', fontSize: '0.72rem' }}>{item.kd_pk.trim()}</span>
                                ) : '—'}
                              </td>
                              <td className="py-1 text-center">
                                <span className="badge rounded-pill" style={{
                                  background: item.jenis === 'K' ? '#fef3c7' : '#d1fae5',
                                  color: item.jenis === 'K' ? '#b45309' : '#065f46',
                                  fontSize: '0.72rem'
                                }}>
                                  {item.jenis === 'K' ? 'Kredit' : item.jenis === 'D' ? 'Debit' : (item.jenis || '—')}
                                </span>
                              </td>
                              <td className="py-1 pe-3 text-end fw-bold text-success">{fmt(item.bank)}</td>
                              <td className="py-1 text-center">
                                <Button variant="primary" size="sm" style={{ fontSize: '0.7rem', padding: '2px 8px' }} onClick={() => handleOpenPosting(item)}>Posting</Button>
                              </td>
                            </>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center py-5 text-muted">
                          <div className="mb-2"><i className="bi bi-inbox fs-3 opacity-50"></i></div>
                          <div style={{ fontSize: '0.8rem' }}>Belum ada data setoran untuk jenis ini.</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                  {listPenerimaan.length > 0 && (
                    <tfoot>
                      <tr style={{ background: '#f8fafc', borderTop: '2px solid #e2e8f0' }}>
                        <td colSpan={jenisPenerimaan === '0' ? 5 : 6} className="py-2 px-3 fw-bold text-muted text-end" style={{ fontSize: '0.8rem' }}>TOTAL</td>
                        <td className="py-2 pe-3 text-end fw-bold text-success" style={{ fontSize: '0.95rem' }}>{fmt(totalPenerimaan)}</td>
                        <td></td>
                      </tr>
                    </tfoot>
                  )}
                </Table>
              </div>
            </div>

            {/* Footer */}
            <div className="d-flex justify-content-between align-items-center px-3 py-2 border-top" style={{ background: '#fff' }}>
              <div className="d-flex align-items-center gap-2 rounded-pill px-3 py-1 shadow-sm" style={{ background: 'linear-gradient(135deg,#0f172a,#0d9488)' }}>
                <i className="bi bi-calculator text-warning"></i>
                <span className="text-white-50 fw-semibold" style={{ fontSize: '0.78rem' }}>TOTAL</span>
                <span className="text-success fw-bold" style={{ fontSize: '1.05rem', fontFamily: 'monospace' }}>Rp {fmt(totalPenerimaan)}</span>
              </div>
              <Button
                variant="light"
                className="d-flex align-items-center gap-2 fw-bold border shadow-sm px-4"
                onClick={() => setShowModalTerima(false)}
                style={{ fontSize: '0.8rem', color: '#dc2626', borderColor: '#fca5a5', borderRadius: '8px' }}
              >
                <i className="bi bi-x-circle-fill"></i> KELUAR
              </Button>
            </div>

          </Modal.Body>
        </Modal>

        {/* MODAL POSTING */}
        <Modal show={showModalPosting} onHide={() => setShowModalPosting(false)} size="lg" backdrop="static" centered>
          <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0284c7 100%)', color: '#fff', padding: '0.5rem 1rem', borderBottom: 'none' }}>
            <Modal.Title className="d-flex align-items-center gap-2 w-100" style={{ fontSize: '0.9rem', fontWeight: 700 }}>
              <div style={{ background: 'rgba(255,255,255,0.15)', borderRadius: '7px', padding: '5px 8px' }}>
                <i className="bi bi-send-check-fill text-warning fs-5"></i>
              </div>
              <span>POSTING SETORAN KASIR TERIMA</span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-0 d-flex flex-column" style={{ minHeight: '60vh', background: '#f0f4f8' }}>

            {/* Info Banner */}
            <div className="px-3 py-2 border-bottom" style={{ background: '#fff' }}>
              <div className="d-flex align-items-center gap-2 rounded-lg overflow-hidden border" style={{ borderRadius: '8px', borderColor: '#e2e8f0' }}>
                <div className="px-3 py-2 text-white fw-semibold d-flex align-items-center gap-2" style={{ background: '#1e293b', fontSize: '0.75rem', whiteSpace: 'nowrap' }}>
                  <i className="bi bi-info-circle text-warning"></i>
                  TANGGAL | NOMOR | NILAI BKU
                </div>
                <div className="px-3 py-2 fw-semibold" style={{ color: '#0284c7', fontSize: '0.82rem' }}>
                  {selectedSetoran?.tanggal || '-'}
                </div>
                <div className="px-3 py-2 fw-bold" style={{ color: '#059669', fontSize: '0.85rem', borderLeft: '1px solid #e2e8f0' }}>
                  {selectedSetoran?.no_bpu || '-'}
                </div>
                <div className="ms-auto px-3 py-2 fw-bold" style={{ color: '#dc2626', fontSize: '0.9rem', borderLeft: '1px solid #e2e8f0', fontFamily: 'monospace' }}>
                  Rp {fmt(jenisPenerimaan === '0' ? (selectedSetoran?.nilai || 0) : (selectedSetoran?.bank || 0))}
                </div>
              </div>
            </div>

            {/* Posting Table */}
            <div className="flex-grow-1 overflow-auto p-2">
              <div className="bg-white border shadow-sm rounded" style={{ borderColor: '#e2e8f0', overflow: 'hidden' }}>
                <Table hover className="mb-0 align-middle" size="sm" style={{ fontSize: '0.8rem' }}>
                  <thead>
                    <tr style={{ background: 'linear-gradient(135deg, #0f172a, #0284c7)', color: '#fff' }}>
                      <th className="py-2 px-3 fw-semibold text-center" style={{ fontSize: '0.7rem', letterSpacing: '0.5px', width: '5%' }}>#</th>
                      <th className="py-2 fw-semibold" style={{ fontSize: '0.7rem', letterSpacing: '0.5px', width: '22%' }}>NOMOR REKENING</th>
                      <th className="py-2 fw-semibold" style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>NOMOR SETORAN</th>
                      <th className="py-2 fw-semibold text-center" style={{ fontSize: '0.7rem', letterSpacing: '0.5px', width: '15%' }}>TANGGAL</th>
                      <th className="py-2 fw-semibold text-end pe-3" style={{ fontSize: '0.7rem', letterSpacing: '0.5px', width: '18%' }}>NILAI [Rp]</th>
                    </tr>
                  </thead>
                  <tbody>
                    {postingRows.map((row, idx) => (
                      <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                        <td className="text-center text-muted fw-medium px-3" style={{ fontSize: '0.75rem' }}>{idx + 1}</td>
                        <td className="p-0">
                          <Select
                            options={listRekening.map(r => ({ value: r.no_rekening || r.kode, label: `${r.no_rekening || r.kode} - ${r.nm_bank}` }))}
                            value={listRekening.map(r => ({ value: r.no_rekening || r.kode, label: `${r.no_rekening || r.kode} - ${r.nm_bank}` })).find(o => o.value === row.norek) || null}
                            onChange={(selected) => handlePostingChange(idx, 'norek', selected ? selected.value : '')}
                            placeholder="Pilih Rekening..."
                            menuPosition="fixed"
                            styles={{
                              control: (base) => ({ 
                                ...base, 
                                minHeight: '28px', 
                                height: '28px', 
                                fontSize: '0.75rem', 
                                border: 'none',
                                borderRadius: 0,
                                borderBottom: row.norek === '' ? '2px solid #f59e0b' : '2px solid transparent',
                                backgroundColor: row.norek === '' ? '#fefce8' : '#fff',
                                boxShadow: 'none',
                                cursor: 'pointer'
                              }),
                              valueContainer: (base) => ({ ...base, padding: '0px 8px' }),
                              indicatorsContainer: (base) => ({ ...base, height: '28px' }),
                              menu: (base) => ({ ...base, fontSize: '0.75rem', zIndex: 9999 })
                            }}
                            isClearable
                          />
                        </td>
                        <td className="p-0">
                          <Form.Control
                            type="text"
                            size="sm"
                            className="border-0 shadow-none rounded-0"
                            style={{ borderBottom: '2px solid transparent' }}
                            placeholder="No. Setoran..."
                            value={row.nosetoran}
                            onChange={(e) => handlePostingChange(idx, 'nosetoran', e.target.value)}
                          />
                        </td>
                        <td className="p-0">
                          <Form.Control
                            type="text"
                            size="sm"
                            className="border-0 shadow-none rounded-0 text-center"
                            style={{ borderBottom: '2px solid transparent' }}
                            value={row.tanggal}
                            onChange={(e) => handlePostingChange(idx, 'tanggal', e.target.value)}
                          />
                        </td>
                        <td className="p-0">
                          <Form.Control
                            type="number"
                            size="sm"
                            className="border-0 shadow-none rounded-0 text-end fw-bold"
                            style={{ color: '#0284c7', borderBottom: '2px solid transparent' }}
                            value={row.nilai === 0 ? '' : row.nilai}
                            placeholder="0"
                            onChange={(e) => handlePostingChange(idx, 'nilai', parseFloat(e.target.value) || 0)}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' && idx === postingRows.length - 1) handleAddPostingRow();
                            }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  {postingRows.length > 0 && (
                    <tfoot>
                      <tr style={{ background: '#f8fafc', borderTop: '2px solid #e2e8f0' }}>
                        <td colSpan="4" className="py-2 px-3 fw-bold text-end text-muted" style={{ fontSize: '0.8rem' }}>TOTAL</td>
                        <td className="py-2 pe-3 text-end fw-bold" style={{ fontSize: '0.9rem', color: '#0284c7', fontFamily: 'monospace' }}>
                          {fmt(postingRows.reduce((sum, r) => sum + (r.nilai || 0), 0))}
                        </td>
                      </tr>
                    </tfoot>
                  )}
                </Table>
              </div>

              <button
                type="button"
                onClick={handleAddPostingRow}
                className="mt-2 d-flex align-items-center gap-1 text-primary border-0 bg-transparent fw-semibold"
                style={{ fontSize: '0.78rem', cursor: 'pointer', padding: '4px 0' }}
              >
                <i className="bi bi-plus-circle"></i> Tambah Baris
              </button>
            </div>

            {/* Footer */}
            <div className="d-flex align-items-center gap-2 px-3 py-2 border-top" style={{ background: '#fff' }}>
              <div className="d-flex align-items-center gap-2 px-2 py-1 rounded flex-grow-1 border" style={{ borderColor: '#e2e8f0', background: '#f8fafc' }}>
                <i className="bi bi-chat-left-text text-muted" style={{ fontSize: '0.8rem' }}></i>
                <Form.Control
                  type="text"
                  size="sm"
                  className="border-0 shadow-none bg-transparent p-0"
                  style={{ fontSize: '0.82rem' }}
                  placeholder="Keterangan tambahan..."
                  value={keteranganPosting}
                  onChange={(e) => setKeteranganPosting(e.target.value)}
                />
              </div>
              <div className="d-flex gap-2">
                <Button
                  variant="primary"
                  size="sm"
                  onClick={handleProsesPosting}
                  className="d-flex align-items-center gap-2 fw-bold shadow-sm px-3"
                  disabled={postingRows.reduce((sum, r) => sum + (r.nilai || 0), 0) !== (jenisPenerimaan === '0' ? (selectedSetoran?.nilai || 0) : (selectedSetoran?.bank || 0))}
                  style={{ 
                    background: postingRows.reduce((sum, r) => sum + (r.nilai || 0), 0) !== (jenisPenerimaan === '0' ? (selectedSetoran?.nilai || 0) : (selectedSetoran?.bank || 0)) 
                                ? '#94a3b8' 
                                : 'linear-gradient(135deg, #0284c7, #0369a1)', 
                    border: 'none', 
                    fontSize: '0.8rem', 
                    borderRadius: '7px',
                    cursor: postingRows.reduce((sum, r) => sum + (r.nilai || 0), 0) !== (jenisPenerimaan === '0' ? (selectedSetoran?.nilai || 0) : (selectedSetoran?.bank || 0)) ? 'not-allowed' : 'pointer'
                  }}
                  title={postingRows.reduce((sum, r) => sum + (r.nilai || 0), 0) !== (jenisPenerimaan === '0' ? (selectedSetoran?.nilai || 0) : (selectedSetoran?.bank || 0)) ? "Total Nilai harus sama dengan Nilai BKU" : ""}
                >
                  <i className="bi bi-send-check-fill"></i> PROSES
                </Button>
                <Button
                  variant="light"
                  size="sm"
                  className="d-flex align-items-center gap-2 fw-bold border shadow-sm px-3"
                  onClick={() => setShowModalPosting(false)}
                  style={{ fontSize: '0.8rem', color: '#dc2626', borderColor: '#fca5a5', borderRadius: '7px' }}
                >
                  <i className="bi bi-x-circle-fill"></i> KELUAR
                </Button>
              </div>
            </div>

          </Modal.Body>
        </Modal>

        {/* MODAL VIEW PDF */}
        <Modal show={showModalPdf} onHide={() => { setShowModalPdf(false); setTimeout(() => setPdfUrl(''), 300); }} size="xl" centered backdrop="static">
          <Modal.Header closeButton={!!pdfUrl} style={{ background: '#1e293b', color: '#fff', borderBottom: '2px solid #0ea5e9' }} className="py-2 px-3">
            <Modal.Title style={{ fontSize: '0.9rem', fontWeight: 600 }}>
              <i className="bi bi-file-earmark-pdf text-danger me-2"></i>
              LAPORAN KAS SEMENTARA
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-0 bg-light position-relative" style={{ height: '75vh' }}>
            {pdfUrl ? (
              <iframe 
                src={pdfUrl} 
                title="Laporan Kas Sementara" 
                width="100%" 
                height="100%" 
                style={{ border: 'none' }}
              />
            ) : (
              <div className="d-flex flex-column h-100 justify-content-center align-items-center bg-white">
                <div className="text-center mb-4">
                  <i className="bi bi-printer text-primary" style={{ fontSize: '4rem', opacity: 0.8 }}></i>
                  <h5 className="mt-3 fw-bold text-dark">Memproses Laporan...</h5>
                  <p className="text-muted small">Sistem sedang merender dokumen PDF dari server.</p>
                </div>
                <div style={{ width: '50%' }}>
                  <ProgressBar animated now={pdfProgress} label={`${pdfProgress}%`} variant="primary" style={{ height: '20px', borderRadius: '10px' }} />
                </div>
              </div>
            )}
          </Modal.Body>
        </Modal>

        {/* MODAL ALERT */}
        <Modal show={alertState.show} onHide={() => setAlertState({ ...alertState, show: false })} centered backdrop="static" size="sm">
          <Modal.Body className="text-center p-4">
            <div className={`text-${alertState.variant} mb-3`}>
              {alertState.variant === 'success' && <i className="bi bi-check-circle-fill" style={{ fontSize: '3.5rem' }}></i>}
              {alertState.variant === 'warning' && <i className="bi bi-exclamation-triangle-fill" style={{ fontSize: '3.5rem' }}></i>}
              {alertState.variant === 'danger' && <i className="bi bi-x-circle-fill" style={{ fontSize: '3.5rem' }}></i>}
              {alertState.variant === 'info' && <i className="bi bi-info-circle-fill" style={{ fontSize: '3.5rem' }}></i>}
            </div>
            <h5 className="mb-3 fw-bold" style={{ color: '#334155' }}>
              {alertState.variant === 'success' ? 'Berhasil!' : alertState.variant === 'warning' ? 'Perhatian!' : alertState.variant === 'danger' ? 'Gagal!' : 'Informasi'}
            </h5>
            <p className="text-muted mb-4" style={{ fontSize: '0.9rem' }}>{alertState.message}</p>
            <Button 
              variant={alertState.variant} 
              className="w-100 fw-bold rounded-pill shadow-sm" 
              onClick={() => setAlertState({ ...alertState, show: false })}
            >
              OK, MENGERTI
            </Button>
          </Modal.Body>
        </Modal>

        {/* MODAL LAPORAN BUKU KAS BENDAHARA */}
        <Modal show={showModalLapKas} onHide={() => setShowModalLapKas(false)} centered backdrop="static" size="md">
          <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #0284c7 100%)', color: '#fff', borderBottom: 'none', padding: '0.6rem 1.2rem' }}>
            <Modal.Title className="d-flex align-items-center gap-2" style={{ fontSize: '0.9rem', fontWeight: 700, letterSpacing: '0.5px' }}>
              <div style={{ background: 'rgba(255,255,255,0.15)', borderRadius: '7px', padding: '4px 8px' }}>
                <i className="bi bi-journal-text text-warning"></i>
              </div>
              LAPORAN BUKU KAS BENDAHARA
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="p-0 bg-light">

            {/* Form Panel */}
            <div className="p-3">
              <div className="bg-white rounded shadow-sm overflow-hidden" style={{ border: '1px solid #dee2e6' }}>

                {/* Row: Jenis */}
                <div className="d-flex align-items-center" style={{ borderBottom: '1px solid #dee2e6' }}>
                  <div className="fw-semibold text-secondary px-3 py-2" style={{ fontSize: '0.82rem', minWidth: '140px', letterSpacing: '0.3px', borderRight: '1px solid #dee2e6' }}>
                    JENIS
                  </div>
                  <div className="px-3 py-2 d-flex align-items-center gap-4 flex-grow-1 bg-white" style={{ fontSize: '0.85rem' }}>
                    <Form.Check 
                      type="radio" id="radio-all" name="lapJenis"
                      checked={lapJenis === 'all'} 
                      onChange={() => setLapJenis('all')}
                      label={
                        <span className="fw-semibold" style={{ 
                          color: lapJenis === 'all' ? '#0284c7' : '#475569', 
                          borderBottom: lapJenis === 'all' ? '2px solid #0284c7' : 'none',
                          paddingBottom: '1px'
                        }}>Seluruh Rekening</span>
                      }
                      style={{ cursor: 'pointer' }}
                    />
                    <Form.Check 
                      type="radio" id="radio-per" name="lapJenis"
                      checked={lapJenis === 'per'} 
                      onChange={() => setLapJenis('per')}
                      label={
                        <span className="fw-semibold" style={{ 
                          color: lapJenis === 'per' ? '#0284c7' : '#475569',
                          borderBottom: lapJenis === 'per' ? '2px solid #0284c7' : 'none',
                          paddingBottom: '1px'
                        }}>Per Rekening</span>
                      }
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                </div>

                {/* Row: Kode Rekening */}
                <div className="d-flex align-items-center" style={{ borderBottom: '1px solid #dee2e6' }}>
                  <div className="fw-semibold text-secondary px-3 py-2" style={{ fontSize: '0.82rem', minWidth: '140px', letterSpacing: '0.3px', borderRight: '1px solid #dee2e6' }}>
                    KODE REKENING
                  </div>
                  <div className="flex-grow-1 bg-white" style={{ opacity: lapJenis === 'all' ? 0.5 : 1 }}>
                    <Select 
                      options={listRekening.map(r => ({ 
                        value: r.kode, 
                        label: r.kode + ' — ' + r.nm_bank,
                        sublabel: r.no_rekening
                      }))}
                      value={listRekening.map(r => ({ value: r.kode, label: r.kode + ' — ' + r.nm_bank, sublabel: r.no_rekening })).find(o => o.value === lapKdBank) || null}
                      onChange={(selected) => setLapKdBank(selected ? selected.value : '')}
                      placeholder="Cari kode atau nama rekening..."
                      isDisabled={lapJenis === 'all'}
                      isSearchable={true}
                      isClearable={true}
                      noOptionsMessage={() => 'Rekening tidak ditemukan'}
                      formatOptionLabel={(opt) => (
                        <div>
                          <div style={{ fontWeight: 600, fontSize: '0.82rem', color: '#1e293b' }}>{opt.label}</div>
                          {opt.sublabel && <div style={{ fontSize: '0.72rem', color: '#64748b' }}>No. Rek: {opt.sublabel}</div>}
                        </div>
                      )}
                      styles={{ 
                        control: (base, state) => ({ 
                          ...base, 
                          minHeight: '36px', 
                          fontSize: '0.82rem', 
                          border: 'none', 
                          borderRadius: 0, 
                          boxShadow: state.isFocused ? 'inset 0 -2px 0 #0ea5e9' : 'none'
                        }), 
                        valueContainer: (base) => ({ ...base, padding: '0px 12px' }),
                        indicatorsContainer: (base) => ({ ...base, height: '36px' }),
                        menu: (base) => ({ ...base, zIndex: 9999, fontSize: '0.82rem', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }),
                        option: (base, state) => ({
                          ...base,
                          background: state.isSelected ? '#0ea5e9' : state.isFocused ? '#f0f9ff' : '#fff',
                          color: state.isSelected ? '#fff' : '#1e293b',
                          padding: '6px 12px',
                        })
                      }}
                      menuPosition="fixed"
                    />
                  </div>
                </div>

                {/* Row: Periode */}
                <div className="d-flex align-items-center">
                  <div className="fw-semibold text-secondary px-3 py-2" style={{ fontSize: '0.82rem', minWidth: '140px', letterSpacing: '0.3px', borderRight: '1px solid #dee2e6' }}>
                    PERIODE
                  </div>
                  <div className="px-3 py-2 d-flex align-items-center gap-2 flex-grow-1 bg-white">
                    <Form.Control 
                      type="date" size="sm"
                      value={lapPeriode1}
                      onChange={(e) => setLapPeriode1(e.target.value)}
                      style={{ width: '145px', fontSize: '0.82rem', borderColor: '#ced4da' }}
                    />
                    <div className="fw-semibold text-secondary px-2 py-1 text-center" style={{ fontSize: '0.82rem', minWidth: '38px' }}>s/d</div>
                    <Form.Control 
                      type="date" size="sm"
                      value={lapPeriode2}
                      onChange={(e) => setLapPeriode2(e.target.value)}
                      style={{ width: '145px', fontSize: '0.82rem', borderColor: '#ced4da' }}
                    />
                  </div>
                </div>

              </div>

              {/* Info Output */}
              <div className="d-flex align-items-center gap-2 mt-2 px-3 py-2 rounded" style={{ background: '#eff6ff', border: '1px solid #bfdbfe' }}>
                <i className="bi bi-file-earmark-pdf-fill text-danger" style={{ fontSize: '1.1rem' }}></i>
                <span className="text-primary fw-semibold" style={{ fontSize: '0.8rem' }}>Hasil laporan akan ditampilkan sebagai dokumen PDF di layar</span>
              </div>
            </div>

            {/* Footer Actions */}
            <div className="d-flex justify-content-end gap-2 px-3 pb-3">
              <Button
                style={{ background: 'linear-gradient(135deg, #1e3a5f, #0ea5e9)', border: 'none', borderRadius: '8px', fontSize: '0.85rem', letterSpacing: '0.3px', minWidth: '120px' }}
                className="fw-bold shadow-sm d-flex align-items-center justify-content-center gap-2 py-2"
                onClick={handleCetakLaporanKas}
              >
                <i className="bi bi-printer-fill"></i> PROSES
              </Button>
              <Button
                variant="outline-secondary"
                style={{ borderRadius: '8px', fontSize: '0.85rem', minWidth: '100px' }}
                className="fw-semibold d-flex align-items-center justify-content-center gap-2 py-2"
                onClick={() => setShowModalLapKas(false)}
              >
                <i className="bi bi-x-lg"></i> TUTUP
              </Button>
            </div>
          </Modal.Body>
        </Modal>

        {/* MODAL LAPORAN KARTU DAN BUKU PIUTANG (MODERN & PROFESSIONAL UI) */}
        <Modal 
          show={showModalKartuBukuPiutang} 
          onHide={() => !lpIsProcessing && setShowModalKartuBukuPiutang(false)} 
          size="lg" 
          centered 
          backdrop="static"
          contentClassName="border-0 shadow-lg"
          style={{ borderRadius: '16px' }}
        >
          {/* Header */}
          <div 
            style={{ 
              background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0369a1 100%)', 
              color: '#ffffff', 
              padding: '14px 20px', 
              borderTopLeftRadius: '12px', 
              borderTopRightRadius: '12px' 
            }} 
            className="d-flex justify-content-between align-items-center shadow-sm"
          >
            <div className="d-flex align-items-center gap-3">
              <div 
                className="d-flex align-items-center justify-content-center rounded-3 shadow-sm" 
                style={{ width: '38px', height: '38px', background: 'rgba(255, 255, 255, 0.12)', backdropFilter: 'blur(6px)', border: '1px solid rgba(255, 255, 255, 0.2)' }}
              >
                <i className="bi bi-journal-bookmark-fill text-warning fs-5"></i>
              </div>
              <div>
                <div className="fw-bold text-white fs-6" style={{ letterSpacing: '0.3px' }}>
                  LAPORAN KARTU & BUKU PIUTANG
                </div>
                <div className="text-white-50" style={{ fontSize: '0.73rem' }}>
                  Rekonsiliasi kartu piutang dan buku saldo piutang penjamin
                </div>
              </div>
            </div>
            <button 
              type="button" 
              className="btn-close btn-close-white shadow-none" 
              disabled={lpIsProcessing}
              onClick={() => setShowModalKartuBukuPiutang(false)} 
              style={{ fontSize: '0.8rem', opacity: 0.85 }}
            ></button>
          </div>

          <Modal.Body className="p-3" style={{ backgroundColor: '#f8fafc' }}>
            {/* Segmented Tab Switcher */}
            <div className="p-1 rounded-3 d-flex mb-3 shadow-sm border bg-white" style={{ borderColor: '#e2e8f0' }}>
              <button
                type="button"
                className={`btn btn-sm w-50 py-2 fw-semibold d-flex align-items-center justify-content-center gap-2 border-0 ${
                  lpJenisLaporan === 'kartu' 
                    ? 'shadow-sm rounded-2 text-white' 
                    : 'text-secondary'
                }`}
                onClick={() => setLpJenisLaporan('kartu')}
                style={{ 
                  background: lpJenisLaporan === 'kartu' ? 'linear-gradient(135deg, #0284c7, #0369a1)' : 'transparent',
                  transition: 'all 0.2s', 
                  fontSize: '0.82rem' 
                }}
              >
                <i className="bi bi-card-checklist fs-6"></i>
                <span>KARTU PIUTANG</span>
              </button>
              <button
                type="button"
                className={`btn btn-sm w-50 py-2 fw-semibold d-flex align-items-center justify-content-center gap-2 border-0 ${
                  lpJenisLaporan === 'buku' 
                    ? 'shadow-sm rounded-2 text-white' 
                    : 'text-secondary'
                }`}
                onClick={() => setLpJenisLaporan('buku')}
                style={{ 
                  background: lpJenisLaporan === 'buku' ? 'linear-gradient(135deg, #0284c7, #0369a1)' : 'transparent',
                  transition: 'all 0.2s', 
                  fontSize: '0.82rem' 
                }}
              >
                <i className="bi bi-journal-text fs-6"></i>
                <span>BUKU PIUTANG</span>
              </button>
            </div>

            {/* Form Card Panel */}
            <div className="bg-white rounded-3 p-3 shadow-sm border mb-3" style={{ borderColor: '#e2e8f0' }}>
              {/* Field 1: Jenis Piutang */}
              <div className="mb-3">
                <Form.Label className="fw-semibold text-dark mb-2" style={{ fontSize: '0.78rem' }}>
                  <i className="bi bi-shield-check text-primary me-1"></i> Kategori Penjamin / Jenis Piutang
                </Form.Label>
                <div className="row g-2">
                  {[
                    { val: '1', label: 'Perusahaan / Penjamin', icon: 'bi-building' },
                    { val: '2', label: 'Dokter', icon: 'bi-person-badge' },
                    { val: '3', label: 'Karyawan', icon: 'bi-people' }
                  ].map((item) => {
                    const isSelected = lpJenisPiutang === item.val;
                    return (
                      <div className="col-4" key={item.val}>
                        <div
                          onClick={() => {
                            setLpJenisPiutang(item.val);
                            setLpKdDebitor('');
                            setLpNmDebitor('');
                          }}
                          className={`p-2 rounded-2 text-center transition-all ${
                            isSelected 
                              ? 'border-primary bg-primary-subtle text-primary fw-bold shadow-sm' 
                              : 'bg-light text-secondary fw-medium border'
                          }`}
                          style={{ 
                            fontSize: '0.78rem', 
                            cursor: 'pointer',
                            transition: 'all 0.2s',
                            border: isSelected ? '1.5px solid #0284c7' : '1px solid #e2e8f0'
                          }}
                        >
                          <i className={`bi ${item.icon} me-1`}></i>
                          {item.label}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Field 2: Debitor Selection */}
              <div className="mb-3">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <Form.Label className="fw-semibold text-dark mb-0" style={{ fontSize: '0.78rem' }}>
                    <i className="bi bi-person-lines-fill text-primary me-1"></i> Debitor / Nama Penjamin
                  </Form.Label>
                  <Form.Check 
                    type="switch" 
                    id="sw-semua-debitor" 
                    checked={lpSemuaDebitor} 
                    onChange={(e) => setLpSemuaDebitor(e.target.checked)}
                    label={<span className="fw-bold text-secondary" style={{ fontSize: '0.75rem' }}>PILIH SELURUH DEBITOR</span>}
                    className="cursor-pointer"
                  />
                </div>

                {lpSemuaDebitor ? (
                  <div 
                    className="p-2 px-3 rounded-2 border d-flex align-items-center gap-2" 
                    style={{ backgroundColor: '#f8fafc', borderColor: '#e2e8f0', fontSize: '0.8rem', color: '#475569' }}
                  >
                    <i className="bi bi-check2-all text-primary fs-5"></i>
                    <span>Memproses seluruh data debitor pada kategori <b>{lpJenisPiutang === '1' ? 'Perusahaan' : (lpJenisPiutang === '2' ? 'Dokter' : 'Karyawan')}</b> secara kolektif.</span>
                  </div>
                ) : (
                  <div className="d-flex align-items-center gap-2">
                    <InputGroup size="sm" style={{ width: '120px' }}>
                      <InputGroup.Text className="bg-light text-muted px-2" style={{ fontSize: '0.75rem', borderColor: '#cbd5e1' }}>
                        Kode
                      </InputGroup.Text>
                      <Form.Control 
                        type="text" 
                        placeholder="Kode"
                        value={lpKdDebitor}
                        onChange={(e) => handleChangeKdDebitor(e.target.value)}
                        style={{ fontSize: '0.8rem', fontWeight: 600, borderColor: '#cbd5e1' }}
                      />
                    </InputGroup>
                    <div style={{ flex: '1 1 auto' }}>
                      <Select 
                        options={lpDebitorList.map(d => ({ value: d.kode, label: `${d.kode} — ${d.nama}` }))}
                        value={lpDebitorList.map(d => ({ value: d.kode, label: `${d.kode} — ${d.nama}` })).find(o => o.value === lpKdDebitor) || null}
                        onChange={handleSelectDebitor}
                        placeholder="- Pilih / Cari Nama Debitor -"
                        isClearable={true}
                        isSearchable={true}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            minHeight: '34px',
                            height: '34px',
                            fontSize: '0.8rem',
                            borderRadius: '6px',
                            borderColor: state.isFocused ? '#0ea5e9' : '#cbd5e1',
                            boxShadow: state.isFocused ? '0 0 0 1px #0ea5e9' : 'none'
                          }),
                          valueContainer: (base) => ({ ...base, padding: '0px 10px' }),
                          indicatorsContainer: (base) => ({ ...base, height: '34px' }),
                          menu: (base) => ({ ...base, zIndex: 99999, fontSize: '0.8rem', borderRadius: '8px', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)' }),
                          option: (base, state) => ({
                            ...base,
                            background: state.isSelected ? '#0ea5e9' : state.isFocused ? '#f0f9ff' : '#fff',
                            color: state.isSelected ? '#fff' : '#1e293b',
                            padding: '6px 12px'
                          })
                        }}
                        menuPosition="fixed"
                      />
                    </div>
                  </div>
                )}
              </div>

              {/* Field 3: Periode Laporan */}
              <div>
                <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                  <i className="bi bi-calendar3 text-primary me-1"></i> Periode Laporan
                </Form.Label>

                {lpJenisLaporan === 'kartu' ? (
                  <div className="d-flex align-items-center gap-2">
                    <InputGroup size="sm" className="flex-grow-1">
                      <InputGroup.Text className="bg-light text-muted px-2" style={{ fontSize: '0.75rem', borderColor: '#cbd5e1' }}>
                        <i className="bi bi-calendar-event"></i>
                      </InputGroup.Text>
                      <Form.Control 
                        type="date" 
                        value={lpPeriode1} 
                        onChange={(e) => setLpPeriode1(e.target.value)} 
                        style={{ fontSize: '0.82rem', borderColor: '#cbd5e1' }} 
                      />
                    </InputGroup>
                    <span className="fw-semibold text-muted px-1" style={{ fontSize: '0.8rem' }}>s/d</span>
                    <InputGroup size="sm" className="flex-grow-1">
                      <InputGroup.Text className="bg-light text-muted px-2" style={{ fontSize: '0.75rem', borderColor: '#cbd5e1' }}>
                        <i className="bi bi-calendar-event"></i>
                      </InputGroup.Text>
                      <Form.Control 
                        type="date" 
                        value={lpPeriode2} 
                        onChange={(e) => setLpPeriode2(e.target.value)} 
                        style={{ fontSize: '0.82rem', borderColor: '#cbd5e1' }} 
                      />
                    </InputGroup>
                  </div>
                ) : (
                  <div className="row g-2">
                    <div className="col-8">
                      <InputGroup size="sm">
                        <InputGroup.Text className="bg-light text-muted px-2" style={{ fontSize: '0.75rem', borderColor: '#cbd5e1' }}>
                          Bulan
                        </InputGroup.Text>
                        <Form.Select 
                          value={lpBulan} 
                          onChange={(e) => setLpBulan(e.target.value)}
                          style={{ fontSize: '0.82rem', borderColor: '#cbd5e1' }}
                        >
                          {['01 - Januari', '02 - Februari', '03 - Maret', '04 - April', '05 - Mei', '06 - Juni', '07 - Juli', '08 - Agustus', '09 - September', '10 - Oktober', '11 - November', '12 - Desember'].map((m, idx) => (
                            <option key={idx} value={String(idx + 1).padStart(2, '0')}>{m}</option>
                          ))}
                        </Form.Select>
                      </InputGroup>
                    </div>
                    <div className="col-4">
                      <InputGroup size="sm">
                        <InputGroup.Text className="bg-light text-muted px-2" style={{ fontSize: '0.75rem', borderColor: '#cbd5e1' }}>
                          Tahun
                        </InputGroup.Text>
                        <Form.Control 
                          type="number" 
                          value={lpTahun} 
                          onChange={(e) => setLpTahun(e.target.value)} 
                          style={{ fontSize: '0.82rem', borderColor: '#cbd5e1' }} 
                        />
                      </InputGroup>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Info Hint */}
            <div className="p-2 px-3 rounded-3 d-flex align-items-center gap-2 mb-3" style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', fontSize: '0.78rem', color: '#166534' }}>
              <i className="bi bi-file-earmark-pdf-fill text-success fs-5"></i>
              <span>Dokumen laporan akan diproses secara instan dan langsung dibuka di penampil PDF untuk dicetak atau diunduh.</span>
            </div>

            {/* Processing Progress Status */}
            {lpIsProcessing && (
              <div className="mb-3 p-3 rounded-3 bg-white border shadow-sm" style={{ borderColor: '#e2e8f0' }}>
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <span className="fw-semibold text-primary" style={{ fontSize: '0.78rem' }}>
                    <Spinner animation="border" size="sm" className="me-2" />
                    {lpStatusText || 'Sedang memproses...'}
                  </span>
                  <span className="fw-bold text-primary" style={{ fontSize: '0.78rem' }}>{lpProgress}%</span>
                </div>
                <ProgressBar animated now={lpProgress} style={{ height: '8px', borderRadius: '4px' }} />
              </div>
            )}

            {/* Footer Buttons */}
            <div className="d-flex align-items-center justify-content-between pt-2 border-top" style={{ borderColor: '#e2e8f0' }}>
              <div style={{ fontSize: '0.75rem', color: '#64748b' }}>
                <i className="bi bi-info-circle me-1"></i> SIMRS Keuangan & Kas Bendahara
              </div>
              <div className="d-flex align-items-center gap-2">
                <Button 
                  variant="light"
                  disabled={lpIsProcessing}
                  onClick={() => setShowModalKartuBukuPiutang(false)}
                  style={{ 
                    border: '1px solid #cbd5e1', 
                    fontWeight: 600, 
                    fontSize: '0.82rem', 
                    padding: '7px 18px',
                    borderRadius: '8px'
                  }}
                  className="d-flex align-items-center gap-2"
                >
                  <i className="bi bi-x-lg"></i>
                  <span>Tutup</span>
                </Button>

                <Button 
                  disabled={lpIsProcessing}
                  onClick={handleProsesKartuBukuPiutang}
                  style={{ 
                    background: 'linear-gradient(135deg, #0284c7, #0369a1)', 
                    border: 'none',
                    fontWeight: 600, 
                    fontSize: '0.82rem', 
                    padding: '7px 22px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 6px -1px rgba(2, 132, 199, 0.3)'
                  }}
                  className="d-flex align-items-center gap-2 text-white"
                >
                  {lpIsProcessing ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    <i className="bi bi-printer-fill fs-6"></i>
                  )}
                  <span>Proses & Cetak</span>
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* Modal Laporan Harian Kasir (Tunai / Piutang) */}
        <Modal 
          show={showModalKasirHarian} 
          onHide={() => !khIsProcessing && setShowModalKasirHarian(false)} 
          centered 
          size="lg"
        >
          <Modal.Header 
            closeButton={!khIsProcessing} 
            style={{ 
              background: 'linear-gradient(135deg, #1e293b, #0f172a)', 
              color: '#ffffff',
              borderBottom: 'none',
              padding: '16px 24px'
            }}
          >
            <Modal.Title className="fw-bold d-flex align-items-center gap-2" style={{ fontSize: '1.05rem' }}>
              <div className="rounded-circle p-2 d-flex align-items-center justify-content-center" style={{ background: 'rgba(255,255,255,0.1)', width: '36px', height: '36px' }}>
                <i className="bi bi-file-earmark-spreadsheet-fill text-warning fs-6"></i>
              </div>
              <div>
                <div>Laporan Harian Kasir</div>
                <div style={{ fontSize: '0.72rem', fontWeight: 'normal', color: '#94a3b8' }}>
                  Perhitungan & Validasi Jurnal Kasir Tunai / Piutang
                </div>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: '24px', background: '#f8fafc' }}>
            <div className="bg-white p-4 rounded-3 border mb-3 shadow-sm" style={{ borderColor: '#e2e8f0' }}>
              
              {/* Type Selection: Radio Buttons */}
              <div className="mb-4">
                <label className="fw-bold text-dark mb-2 d-block" style={{ fontSize: '0.82rem' }}>
                  <i className="bi bi-journal-check text-primary me-1"></i> Tipe Laporan Validasi
                </label>
                <div className="d-flex align-items-center gap-4 p-3 rounded-3" style={{ background: '#f1f5f9', border: '1px solid #cbd5e1' }}>
                  <Form.Check
                    type="radio"
                    id="radio-kh-tunai"
                    name="khJenisRadio"
                    label={<span className="fw-bold text-dark" style={{ fontSize: '0.88rem' }}><i className="bi bi-cash-stack text-success me-1"></i> ( • ) TUNAI</span>}
                    checked={khJenis === 'TUNAI'}
                    onChange={() => setKhJenis('TUNAI')}
                    className="mb-0 cursor-pointer"
                  />
                  <Form.Check
                    type="radio"
                    id="radio-kh-piutang"
                    name="khJenisRadio"
                    label={<span className="fw-bold text-dark" style={{ fontSize: '0.88rem' }}><i className="bi bi-credit-card-2-front text-primary me-1"></i> ( • ) PIUTANG</span>}
                    checked={khJenis === 'PIUTANG'}
                    onChange={() => setKhJenis('PIUTANG')}
                    className="mb-0 cursor-pointer"
                  />
                </div>
              </div>

              {/* Date Range Inputs */}
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="fw-semibold text-secondary mb-1" style={{ fontSize: '0.8rem' }}>
                    <i className="bi bi-calendar-check me-1 text-primary"></i> TANGGAL LAPORAN
                  </label>
                  <InputGroup size="sm">
                    <InputGroup.Text className="bg-light text-muted px-2" style={{ fontSize: '0.75rem', borderColor: '#cbd5e1' }}>
                      <i className="bi bi-calendar3"></i>
                    </InputGroup.Text>
                    <Form.Control
                      type="date"
                      value={khPeriode1}
                      onChange={(e) => setKhPeriode1(e.target.value)}
                      style={{ fontSize: '0.85rem', borderColor: '#cbd5e1' }}
                    />
                  </InputGroup>
                </div>
                <div className="col-md-6">
                  <label className="fw-semibold text-secondary mb-1" style={{ fontSize: '0.8rem' }}>
                    <i className="bi bi-calendar-event me-1 text-primary"></i> SAMPAI DENGAN TANGGAL
                  </label>
                  <InputGroup size="sm">
                    <InputGroup.Text className="bg-light text-muted px-2" style={{ fontSize: '0.75rem', borderColor: '#cbd5e1' }}>
                      <i className="bi bi-calendar3"></i>
                    </InputGroup.Text>
                    <Form.Control
                      type="date"
                      value={khPeriode2}
                      onChange={(e) => setKhPeriode2(e.target.value)}
                      style={{ fontSize: '0.85rem', borderColor: '#cbd5e1' }}
                    />
                  </InputGroup>
                </div>
              </div>

            </div>

            {/* Info Hint */}
            <div className="p-2 px-3 rounded-3 d-flex align-items-center gap-2 mb-3" style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', fontSize: '0.78rem', color: '#166534' }}>
              <i className="bi bi-file-earmark-pdf-fill text-success fs-5"></i>
              <span>Laporan format PDF landscape A3 akan dibuat dan langsung ditampilkan di layar browser.</span>
            </div>

            {/* Processing Progress Status */}
            {khIsProcessing && (
              <div className="mb-3 p-3 rounded-3 bg-white border shadow-sm" style={{ borderColor: '#e2e8f0' }}>
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <span className="fw-semibold text-primary" style={{ fontSize: '0.78rem' }}>
                    <Spinner animation="border" size="sm" className="me-2" />
                    {khStatusText || 'Sedang memproses...'}
                  </span>
                  <span className="fw-bold text-primary" style={{ fontSize: '0.78rem' }}>{khProgress}%</span>
                </div>
                <ProgressBar animated now={khProgress} style={{ height: '8px', borderRadius: '4px' }} />
              </div>
            )}

            {/* Footer Buttons */}
            <div className="d-flex align-items-center justify-content-between pt-2 border-top" style={{ borderColor: '#e2e8f0' }}>
              <div style={{ fontSize: '0.75rem', color: '#64748b' }}>
                <i className="bi bi-info-circle me-1"></i> SIMRS Keuangan & Kas Bendahara
              </div>
              <div className="d-flex align-items-center gap-2">
                <Button 
                  variant="light"
                  disabled={khIsProcessing}
                  onClick={() => setShowModalKasirHarian(false)}
                  style={{ 
                    border: '1px solid #cbd5e1', 
                    fontWeight: 600, 
                    fontSize: '0.82rem', 
                    padding: '7px 18px',
                    borderRadius: '8px'
                  }}
                  className="d-flex align-items-center gap-2"
                >
                  <i className="bi bi-x-lg"></i>
                  <span>Batal</span>
                </Button>

                <Button 
                  disabled={khIsProcessing}
                  onClick={handleProsesKasirHarianExcel}
                  style={{ 
                    background: 'linear-gradient(135deg, #16a34a, #15803d)', 
                    border: 'none',
                    fontWeight: 600, 
                    fontSize: '0.82rem', 
                    padding: '7px 18px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 6px -1px rgba(22, 163, 74, 0.3)'
                  }}
                  className="d-flex align-items-center gap-2 text-white"
                >
                  {khIsProcessing ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    <i className="bi bi-file-earmark-excel-fill fs-6"></i>
                  )}
                  <span>Export Excel</span>
                </Button>

                <Button 
                  disabled={khIsProcessing}
                  onClick={handleProsesKasirHarian}
                  style={{ 
                    background: 'linear-gradient(135deg, #0284c7, #0369a1)', 
                    border: 'none',
                    fontWeight: 600, 
                    fontSize: '0.82rem', 
                    padding: '7px 22px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 6px -1px rgba(2, 132, 199, 0.3)'
                  }}
                  className="d-flex align-items-center gap-2 text-white"
                >
                  {khIsProcessing ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    <i className="bi bi-file-earmark-pdf-fill fs-6"></i>
                  )}
                  <span>Cetak PDF</span>
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* ============================================================
            MODAL PENERIMAAN NON SETORAN KASIR — MODERN REDESIGN
        ============================================================ */}
        <Modal 
          show={showModalPenerimaanNonKasir} 
          onHide={() => !isProcessingPenerimaan && setShowModalPenerimaanNonKasir(false)} 
          centered 
          size="xl"
          backdrop="static"
        >
          {/* ── HEADER ── */}
          <Modal.Header 
            closeButton={!isProcessingPenerimaan}
            style={{ 
              background: 'linear-gradient(135deg, #1e293b, #0f172a)', 
              color: '#ffffff',
              borderBottom: 'none',
              padding: '10px 16px'
            }}
          >
            <div className="d-flex align-items-center gap-2">
              <div 
                className="d-flex align-items-center justify-content-center rounded-circle"
                style={{ width: 30, height: 30, background: 'rgba(255,255,255,0.12)', flexShrink: 0 }}
              >
                <i className="bi bi-bank text-warning" style={{ fontSize: '0.85rem' }}></i>
              </div>
              <div>
                <div className="fw-bold text-white" style={{ fontSize: '0.9rem', letterSpacing: '0.4px' }}>
                  Penerimaan Non Setoran Kasir
                </div>
                <div style={{ fontSize: '0.7rem', color: '#94a3b8' }}>
                  Kas Bendahara — Input & Proses Penerimaan
                </div>
              </div>
            </div>
          </Modal.Header>

          {/* ── BODY ── */}
          <Modal.Body style={{ padding: '10px 14px', background: '#f1f5f9' }}>

            {/* ── SECTION 1: IDENTITAS TRANSAKSI ── */}
            <div className="bg-white rounded-2 border shadow-sm mb-2" style={{ borderColor: '#e2e8f0', overflow: 'hidden' }}>
              <div 
                className="d-flex align-items-center gap-2 px-2 py-1"
                style={{ background: 'linear-gradient(90deg, #0f4c81, #1d6fa0)', borderBottom: '1px solid #e2e8f0' }}
              >
                <i className="bi bi-file-earmark-text text-warning" style={{ fontSize: '0.78rem' }}></i>
                <span className="fw-bold text-white" style={{ fontSize: '0.72rem', letterSpacing: '0.3px', textTransform: 'uppercase' }}>
                  Identitas Transaksi
                </span>
              </div>
              <div className="px-2 py-2">
                <div className="row g-2">
                  <div className="col-md-4">
                    <Form.Label className="fw-semibold text-secondary mb-1" style={{ fontSize: '0.68rem', textTransform: 'uppercase', letterSpacing: '0.3px' }}>
                      No. Penerimaan / Bukti Setor
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={noPenerimaan}
                      onChange={(e) => setNoPenerimaan(e.target.value)}
                      placeholder="No. Penerimaan..."
                      size="sm"
                      style={{ fontSize: '0.82rem', fontWeight: 600, borderColor: '#cbd5e1' }}
                    />
                  </div>
                  <div className="col-md-4">
                    <Form.Label className="fw-semibold text-secondary mb-1" style={{ fontSize: '0.68rem', textTransform: 'uppercase', letterSpacing: '0.3px' }}>
                      Jenis Terima
                    </Form.Label>
                    <Form.Select
                      value={jenisTerima}
                      onChange={(e) => setJenisTerima(parseInt(e.target.value, 10))}
                      size="sm"
                      style={{ fontSize: '0.82rem', fontWeight: 600, borderColor: '#cbd5e1' }}
                    >
                      <option value={1}>1. Pelunasan Piutang</option>
                      <option value={2}>2. Penerimaan Lain</option>
                      <option value={3}>3. Posting Titipan</option>
                    </Form.Select>
                  </div>
                  <div className="col-md-4">
                    <Form.Label className="fw-semibold text-secondary mb-1" style={{ fontSize: '0.68rem', textTransform: 'uppercase', letterSpacing: '0.3px' }}>
                      Tanggal Transaksi
                    </Form.Label>
                    <Form.Control
                      type="date"
                      value={tglTransaksi}
                      onChange={(e) => setTglTransaksi(e.target.value)}
                      size="sm"
                      style={{ 
                        fontSize: '0.82rem', 
                        fontWeight: 'bold', 
                        color: '#15803d',
                        borderColor: '#86efac',
                        backgroundColor: '#f0fdf4'
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* ── SECTION 2: REKENING BANK ── */}
            <div className="bg-white rounded-2 border shadow-sm mb-2" style={{ borderColor: '#e2e8f0', overflow: 'hidden' }}>
              <div 
                className="d-flex align-items-center gap-2 px-2 py-1"
                style={{ background: 'linear-gradient(90deg, #0e6655, #1a8770)', borderBottom: '1px solid #e2e8f0' }}
              >
                <i className="bi bi-credit-card-2-front text-warning" style={{ fontSize: '0.78rem' }}></i>
                <span className="fw-bold text-white" style={{ fontSize: '0.72rem', letterSpacing: '0.3px', textTransform: 'uppercase' }}>
                  Rekening Bank
                </span>
              </div>
              <div className="px-2 py-2">
                <div className="row g-2">
                  <div className="col-md-5">
                    <Form.Label className="fw-semibold text-secondary mb-1" style={{ fontSize: '0.68rem', textTransform: 'uppercase', letterSpacing: '0.3px' }}>
                      No. Rekening Bank
                    </Form.Label>
                    <Form.Select
                      value={noRekening}
                      onChange={handleSelectRekeningPenerimaan}
                      size="sm"
                      style={{ fontSize: '0.82rem', fontWeight: 600, borderColor: '#cbd5e1' }}
                    >
                      <option value="">-- Pilih No Rekening --</option>
                      {listRekening.map((rek, idx) => (
                        <option key={idx} value={rek.no_rekening || rek.kode}>
                          {rek.no_rekening} {rek.nm_bank ? `- ${rek.nm_bank}` : ''} {rek.keterangan ? `(${rek.keterangan})` : ''}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                  <div className="col-md-4">
                    <Form.Label className="fw-semibold text-secondary mb-1" style={{ fontSize: '0.68rem', textTransform: 'uppercase', letterSpacing: '0.3px' }}>
                      Nama Bank
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={nmBankPenerimaan}
                      onChange={(e) => setNmBankPenerimaan(e.target.value)}
                      placeholder="Nama Bank / Rekening"
                      size="sm"
                      style={{ fontSize: '0.82rem', fontWeight: 600, backgroundColor: '#f8fafc', borderColor: '#cbd5e1' }}
                    />
                  </div>
                  <div className="col-md-3">
                    <Form.Label className="fw-semibold text-secondary mb-1" style={{ fontSize: '0.68rem', textTransform: 'uppercase', letterSpacing: '0.3px' }}>
                      Tanggal Buku Bank
                    </Form.Label>
                    <Form.Control
                      type="date"
                      value={tglBukuBank}
                      onChange={(e) => setTglBukuBank(e.target.value)}
                      size="sm"
                      style={{ fontSize: '0.82rem', fontWeight: 'bold', borderColor: '#cbd5e1' }}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* ── SECTION 3: DATA PENJAMIN ── */}
            <div className="bg-white rounded-2 border shadow-sm mb-2" style={{ borderColor: '#e2e8f0', overflow: 'hidden' }}>
              <div 
                className="d-flex align-items-center gap-2 px-2 py-1"
                style={{ background: 'linear-gradient(90deg, #6d28d9, #8b5cf6)', borderBottom: '1px solid #e2e8f0' }}
              >
                <i className="bi bi-person-badge text-warning" style={{ fontSize: '0.78rem' }}></i>
                <span className="fw-bold text-white" style={{ fontSize: '0.72rem', letterSpacing: '0.3px', textTransform: 'uppercase' }}>
                  Data Penjamin / Pengirim
                </span>
              </div>
              <div className="px-2 py-2">
                <div className="row g-2">
                  <div className="col-md-3">
                    <Form.Label className="fw-semibold text-secondary mb-1" style={{ fontSize: '0.68rem', textTransform: 'uppercase', letterSpacing: '0.3px' }}>
                      Nama Pengirim
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={namaPengirim}
                      onChange={(e) => setNamaPengirim(e.target.value)}
                      placeholder="Nama Pengirim"
                      size="sm"
                      style={{ fontSize: '0.82rem', fontWeight: 600, borderColor: '#cbd5e1' }}
                    />
                  </div>
                  <div className="col-md-3">
                    <Form.Label className="fw-semibold text-secondary mb-1" style={{ fontSize: '0.68rem', textTransform: 'uppercase', letterSpacing: '0.3px' }}>
                      Type Penjamin
                    </Form.Label>
                    <Form.Select
                      value={typePenjamin}
                      onChange={(e) => { 
                        setTypePenjamin(parseInt(e.target.value, 10)); 
                        setKdPrs(''); 
                        setNmPrs(''); 
                      }}
                      size="sm"
                      style={{ fontSize: '0.82rem', fontWeight: 600, borderColor: '#cbd5e1' }}
                    >
                      <option value={1}>1. Perusahaan Rekanan</option>
                      <option value={2}>2. Dokter Rumah Sakit</option>
                      <option value={3}>3. Karyawan</option>
                    </Form.Select>
                  </div>
                  <div className="col-md-2">
                    <Form.Label className="fw-semibold text-secondary mb-1" style={{ fontSize: '0.68rem', textTransform: 'uppercase', letterSpacing: '0.3px' }}>
                      Kode Penjamin
                    </Form.Label>
                    <InputGroup size="sm">
                      <Form.Control
                        type="text"
                        value={kdPrs}
                        onChange={(e) => setKdPrs(e.target.value)}
                        placeholder="Kode"
                        style={{ fontSize: '0.82rem', fontWeight: 600, borderColor: '#cbd5e1' }}
                      />
                      <Button 
                        onClick={handleOpenLookupPenjamin}
                        title="Cari Data Penjamin"
                        style={{ 
                          background: 'linear-gradient(135deg, #0284c7, #0369a1)', 
                          borderColor: '#0284c7',
                          padding: '0 8px'
                        }}
                      >
                        <i className="bi bi-search text-white" style={{ fontSize: '0.75rem' }}></i>
                      </Button>
                    </InputGroup>
                  </div>
                  <div className="col-md-4">
                    <Form.Label className="fw-semibold text-secondary mb-1" style={{ fontSize: '0.68rem', textTransform: 'uppercase', letterSpacing: '0.3px' }}>
                      Nama Perusahaan / Rekanan / Dokter
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={nmPrs}
                      onChange={(e) => setNmPrs(e.target.value)}
                      placeholder="Nama Perusahaan / Rekanan / Dokter"
                      size="sm"
                      style={{ fontSize: '0.82rem', fontWeight: 600, backgroundColor: '#f8fafc', borderColor: '#cbd5e1' }}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* ── SECTION 4: NILAI & KETERANGAN ── */}
            <div className="bg-white rounded-2 border shadow-sm" style={{ borderColor: '#e2e8f0', overflow: 'hidden' }}>
              <div 
                className="d-flex align-items-center gap-2 px-2 py-1"
                style={{ background: 'linear-gradient(90deg, #b45309, #d97706)', borderBottom: '1px solid #e2e8f0' }}
              >
                <i className="bi bi-cash-coin text-white" style={{ fontSize: '0.78rem' }}></i>
                <span className="fw-bold text-white" style={{ fontSize: '0.72rem', letterSpacing: '0.3px', textTransform: 'uppercase' }}>
                  Nilai & Keterangan
                </span>
              </div>
              <div className="px-2 py-2">
                <div className="row g-2 align-items-end">
                  <div className="col-md-3">
                    <Form.Label className="fw-semibold text-secondary mb-1" style={{ fontSize: '0.68rem', textTransform: 'uppercase', letterSpacing: '0.3px' }}>
                      Nilai Penerimaan (Rp)
                    </Form.Label>
                    <Form.Control
                      type="number"
                      value={nilaiPenerimaan}
                      onChange={(e) => setNilaiPenerimaan(e.target.value)}
                      placeholder="0"
                      size="sm"
                      style={{ 
                        fontSize: '1.1rem', 
                        fontWeight: 700, 
                        color: '#1d4ed8', 
                        textAlign: 'right',
                        backgroundColor: '#eff6ff',
                        borderColor: '#93c5fd',
                        borderWidth: 2
                      }}
                    />
                  </div>
                  <div className="col-md-9">
                    <Form.Label className="fw-semibold text-secondary mb-1" style={{ fontSize: '0.68rem', textTransform: 'uppercase', letterSpacing: '0.3px' }}>
                      Keterangan / Uraian Transaksi
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={uraianPenerimaan}
                      onChange={(e) => setUraianPenerimaan(e.target.value)}
                      placeholder="Uraian / keterangan transaksi penerimaan..."
                      size="sm"
                      style={{ fontSize: '0.82rem', fontWeight: 500, borderColor: '#cbd5e1' }}
                    />
                  </div>
                </div>
              </div>
            </div>

          </Modal.Body>

          {/* ── FOOTER / ACTION BAR ── */}
          <Modal.Footer 
            style={{ 
              background: '#f8fafc', 
              borderTop: '1px solid #e2e8f0', 
              padding: '8px 16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
          >
            {/* Nomor Bukti Preview (kiri) */}
            <div 
              className="d-flex align-items-center gap-2 px-3 py-1 rounded-2"
              style={{ 
                background: '#0f172a', 
                border: '1px solid #334155', 
                color: '#38bdf8', 
                fontFamily: 'monospace', 
                fontWeight: 'bold', 
                fontSize: '0.88rem',
                letterSpacing: '0.5px'
              }}
            >
              <i className="bi bi-receipt-cutoff text-warning"></i>
              <span>{noBuktiNext || 'BMB/--/----/---'}</span>
            </div>

            {/* Tombol Aksi (kanan) */}
            <div className="d-flex align-items-center gap-2">
              <Button 
                disabled={isProcessingPenerimaan}
                onClick={() => {
                  setShowModalOtorisasiAngsuran(true);
                }}
                style={{ 
                  fontWeight: 600, 
                  fontSize: '0.78rem', 
                  padding: '5px 12px', 
                  borderRadius: '6px', 
                  background: '#475569', 
                  border: 'none' 
                }}
                className="d-flex align-items-center gap-1 text-white shadow-sm"
              >
                <i className="bi bi-printer-fill"></i>
                <span>Print Ulang</span>
              </Button>

              <Button 
                variant="outline-danger"
                disabled={isProcessingPenerimaan}
                onClick={handleBatalPenerimaan}
                style={{ 
                  fontWeight: 600, 
                  fontSize: '0.78rem', 
                  padding: '5px 12px', 
                  borderRadius: '6px',
                  borderWidth: 2
                }}
                className="d-flex align-items-center gap-1"
              >
                <i className="bi bi-arrow-counterclockwise"></i>
                <span>Reset</span>
              </Button>

              <Button 
                disabled={isProcessingPenerimaan}
                onClick={handleProsesPenerimaanNonKasir}
                style={{ 
                  fontWeight: 700, 
                  fontSize: '0.82rem', 
                  padding: '6px 24px', 
                  borderRadius: '6px', 
                  background: 'linear-gradient(135deg, #16a34a, #15803d)', 
                  border: 'none', 
                  boxShadow: '0 4px 12px -2px rgba(22, 163, 74, 0.4)',
                  minWidth: 110
                }}
                className="d-flex align-items-center justify-content-center gap-1 text-white"
              >
                {isProcessingPenerimaan ? (
                  <><Spinner animation="border" size="sm" /><span>Memproses...</span></>
                ) : (
                  <><i className="bi bi-check2-circle"></i><span>PROSES</span></>
                )}
              </Button>

              <Button 
                disabled={isProcessingPenerimaan}
                onClick={() => setShowModalPenerimaanNonKasir(false)}
                style={{ 
                  fontWeight: 600, 
                  fontSize: '0.78rem', 
                  padding: '5px 12px', 
                  borderRadius: '6px', 
                  background: '#1e293b', 
                  border: 'none' 
                }}
                className="d-flex align-items-center gap-1 text-white shadow-sm"
              >
                <i className="bi bi-x-lg"></i>
                <span>Tutup</span>
              </Button>
            </div>
          </Modal.Footer>
        </Modal>

        {/* Modal Lookup Penjamin (Perusahaan / Dokter / Karyawan) */}
        <Modal 
          show={showModalLookupPenjamin} 
          onHide={() => setShowModalLookupPenjamin(false)} 
          centered 
          size="lg"
        >
          <Modal.Header 
            closeButton 
            style={{ 
              background: 'linear-gradient(135deg, #1e293b, #0f172a)', 
              color: '#ffffff',
              borderBottom: 'none',
              padding: '14px 20px'
            }}
          >
            <div className="d-flex align-items-center gap-2">
              <div 
                className="d-flex align-items-center justify-content-center rounded-circle"
                style={{ width: 32, height: 32, background: 'rgba(255,255,255,0.12)', flexShrink: 0 }}
              >
                <i className="bi bi-search text-warning" style={{ fontSize: '0.85rem' }}></i>
              </div>
              <span className="fw-bold text-white" style={{ fontSize: '0.92rem' }}>
                Cari Data {typePenjamin === 1 ? 'Perusahaan Rekanan' : (typePenjamin === 2 ? 'Dokter Rumah Sakit' : 'Karyawan')}
              </span>
            </div>
          </Modal.Header>
          <Modal.Body style={{ padding: '16px 20px', background: '#f8fafc' }}>
            <div className="d-flex align-items-center gap-2 mb-3">
              <InputGroup>
                <InputGroup.Text style={{ background: '#ffffff', borderColor: '#cbd5e1' }}>
                  <i className="bi bi-search text-secondary"></i>
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Ketik nama atau kode untuk mencari..."
                  value={searchLookupPenjamin}
                  onChange={(e) => {
                    const q = e.target.value;
                    setSearchLookupPenjamin(q);
                    fetchLookupPenjamin(typePenjamin, q);
                  }}
                  style={{ fontSize: '0.85rem' }}
                  autoFocus
                />
              </InputGroup>
              <Button 
                variant="outline-secondary" 
                onClick={() => {
                  setSearchLookupPenjamin('');
                  fetchLookupPenjamin(typePenjamin, '');
                }}
                style={{ fontSize: '0.82rem' }}
              >
                Reset
              </Button>
            </div>

            <div style={{ maxHeight: '380px', overflowY: 'auto', border: '1px solid #cbd5e1', borderRadius: '8px', background: '#fff' }}>
              {isLoadingLookupPenjamin ? (
                <div className="text-center py-4">
                  <Spinner animation="border" size="sm" className="text-primary me-2" />
                  <span style={{ fontSize: '0.85rem', color: '#64748b' }}>Memuat data...</span>
                </div>
              ) : listLookupPenjamin.length === 0 ? (
                <div className="text-center py-4" style={{ fontSize: '0.85rem', color: '#94a3b8' }}>
                  Tidak ada data yang ditemukan.
                </div>
              ) : (
                <Table hover size="sm" className="mb-0 align-middle" style={{ fontSize: '0.82rem' }}>
                  <thead style={{ background: '#f1f5f9', position: 'sticky', top: 0, zIndex: 1 }}>
                    <tr>
                      <th style={{ width: '120px', padding: '8px 12px' }}>Kode</th>
                      <th style={{ padding: '8px 12px' }}>Nama</th>
                      <th style={{ width: '100px', textAlign: 'center', padding: '8px 12px' }}>Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listLookupPenjamin.map((item, idx) => (
                      <tr key={idx} style={{ cursor: 'pointer' }} onClick={() => handlePilihPenjamin(item)}>
                        <td className="fw-bold text-primary" style={{ padding: '7px 12px' }}>{item.kd_prs}</td>
                        <td style={{ padding: '7px 12px' }}>{item.nm_prs}</td>
                        <td style={{ textAlign: 'center', padding: '7px 12px' }}>
                          <Button 
                            variant="primary" 
                            size="sm" 
                            onClick={(e) => {
                              e.stopPropagation();
                              handlePilihPenjamin(item);
                            }}
                            style={{ fontSize: '0.75rem', padding: '3px 10px', borderRadius: '4px' }}
                          >
                            Pilih
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </div>
          </Modal.Body>
        </Modal>

        {/* Modal Nota Penerimaan (Bukti Pembayaran / Print Ulang) */}
        <Modal 
          show={showModalNotaPenerimaan} 
          onHide={() => setShowModalNotaPenerimaan(false)} 
          centered 
          size="lg"
        >
          <Modal.Header 
            closeButton 
            style={{ 
              background: '#002b49', 
              color: '#ffffff',
              borderBottom: 'none',
              padding: '12px 20px'
            }}
          >
            <Modal.Title className="fw-bold d-flex align-items-center gap-2" style={{ fontSize: '0.95rem' }}>
              <i className="bi bi-printer-fill text-warning"></i>
              <span>Bukti Penerimaan Kas Bendahara</span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: '20px', background: '#0f172a' }}>
            <pre 
              style={{ 
                background: '#1e293b', 
                color: '#38bdf8', 
                padding: '16px', 
                borderRadius: '8px', 
                border: '1px solid #334155',
                fontSize: '0.82rem',
                fontFamily: 'Consolas, Monaco, "Courier New", monospace',
                whiteSpace: 'pre-wrap',
                margin: 0,
                maxHeight: '460px',
                overflowY: 'auto'
              }}
            >
              {notaPenerimaanText}
            </pre>
          </Modal.Body>
          <Modal.Footer style={{ background: '#f8fafc', padding: '10px 20px' }}>
            <Button 
              variant="outline-secondary" 
              onClick={() => setShowModalNotaPenerimaan(false)}
              style={{ fontSize: '0.82rem', padding: '6px 16px', borderRadius: '6px' }}
            >
              Tutup
            </Button>
            <Button 
              variant="primary" 
              onClick={() => {
                const printWin = window.open('', '_blank');
                if (printWin) {
                  printWin.document.write(`
                    <html>
                      <head>
                        <title>Nota Penerimaan Kas Bendahara</title>
                        <style>
                          body { font-family: monospace; font-size: 12px; margin: 20px; white-space: pre-wrap; }
                        </style>
                      </head>
                      <body>${notaPenerimaanText}</body>
                    </html>
                  `);
                  printWin.document.close();
                  printWin.focus();
                  printWin.print();
                  printWin.close();
                }
              }}
              style={{ fontSize: '0.82rem', padding: '6px 20px', borderRadius: '6px', background: '#0284c7', border: 'none' }}
              className="d-flex align-items-center gap-2"
            >
              <i className="bi bi-printer-fill"></i>
              <span>Cetak Nota</span>
            </Button>
          </Modal.Footer>
        </Modal>

        {/* ============================================================
            MODAL INPUT TANGGAL OTORISASI ANGSURAN (PRINT ULANG)
        ============================================================ */}
        <Modal 
          show={showModalOtorisasiAngsuran} 
          onHide={() => !isLoadingCetakTitip && setShowModalOtorisasiAngsuran(false)} 
          centered 
          size="md"
          backdrop="static"
        >
          <Modal.Header 
            closeButton={!isLoadingCetakTitip}
            style={{ 
              background: 'linear-gradient(135deg, #1e293b, #0f172a)', 
              color: '#ffffff',
              borderBottom: 'none',
              padding: '10px 16px'
            }}
          >
            <div className="d-flex align-items-center gap-2">
              <div 
                className="d-flex align-items-center justify-content-center rounded-circle"
                style={{ width: 30, height: 30, background: 'rgba(255,255,255,0.12)', flexShrink: 0 }}
              >
                <i className="bi bi-calendar-check text-warning" style={{ fontSize: '0.85rem' }}></i>
              </div>
              <div>
                <div className="fw-bold text-white" style={{ fontSize: '0.88rem', letterSpacing: '0.3px' }}>
                  TANGGAL OTORISASI ANGSURAN
                </div>
                <div style={{ fontSize: '0.68rem', color: '#94a3b8' }}>
                  Cetak Ulang Laporan Jurnal Kasir Titip Ulang
                </div>
              </div>
            </div>
          </Modal.Header>

          <Modal.Body style={{ padding: '16px', background: '#f8fafc' }}>
            {/* Fieldset / Bordered Group Box matching screenshot */}
            <div 
              className="p-3 rounded-2 bg-white border shadow-sm"
              style={{ borderColor: '#cbd5e1' }}
            >
              <div 
                className="fw-bold text-primary mb-2 text-uppercase" 
                style={{ fontSize: '0.75rem', letterSpacing: '0.5px' }}
              >
                <i className="bi bi-journal-text me-1"></i> Tanggal Otorisasi Angsuran
              </div>

              <div className="input-group">
                <span 
                  className="input-group-text text-white fw-bold text-uppercase"
                  style={{ 
                    background: '#0b4d8c', 
                    borderColor: '#0b4d8c', 
                    fontSize: '0.75rem',
                    letterSpacing: '0.3px',
                    padding: '6px 12px'
                  }}
                >
                  Tanggal Otorisasi
                </span>
                <input 
                  type="date" 
                  className="form-control fw-bold"
                  value={tglOtorisasiAngsuran}
                  onChange={(e) => setTglOtorisasiAngsuran(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleCetakJurnalTitipUlang();
                    }
                  }}
                  style={{ 
                    fontSize: '0.85rem', 
                    borderColor: '#0b4d8c',
                    backgroundColor: '#fef9c3',
                    color: '#0f172a'
                  }}
                />
              </div>
              <div className="mt-2 text-muted" style={{ fontSize: '0.68rem' }}>
                * Masukkan tanggal otorisasi untuk mencetak rekapitulasi jurnal titipan kas bendahara.
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer style={{ background: '#f1f5f9', padding: '8px 16px' }}>
            <Button 
              variant="outline-secondary" 
              size="sm"
              disabled={isLoadingCetakTitip}
              onClick={() => setShowModalOtorisasiAngsuran(false)}
              style={{ fontSize: '0.78rem', padding: '5px 14px', borderRadius: '6px' }}
            >
              Batal
            </Button>
            <Button 
              size="sm"
              disabled={isLoadingCetakTitip}
              onClick={handleCetakJurnalTitipUlang}
              style={{ 
                fontSize: '0.8rem', 
                fontWeight: 600,
                padding: '6px 18px', 
                borderRadius: '6px',
                background: 'linear-gradient(135deg, #0284c7, #0369a1)',
                border: 'none',
                boxShadow: '0 2px 6px rgba(2, 132, 199, 0.35)'
              }}
              className="d-flex align-items-center gap-2 text-white"
            >
              {isLoadingCetakTitip ? (
                <>
                  <Spinner animation="border" size="sm" />
                  <span>Memproses PDF...</span>
                </>
              ) : (
                <>
                  <i className="bi bi-file-earmark-pdf-fill text-warning"></i>
                  <span>Cetak PDF</span>
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* ============================================================
            MODAL VIEW PDF JURNAL TITIP ULANG (IN-APP PREVIEW)
        ============================================================ */}
        <Modal 
          show={showModalPdfTitip} 
          onHide={() => {
            setShowModalPdfTitip(false);
            if (pdfTitipUrl) {
              URL.revokeObjectURL(pdfTitipUrl);
              setPdfTitipUrl('');
            }
          }} 
          size="xl" 
          centered 
          backdrop="static"
        >
          <Modal.Header 
            closeButton 
            style={{ 
              background: 'linear-gradient(135deg, #1e293b, #0f172a)', 
              color: '#ffffff', 
              borderBottom: '2px solid #0284c7',
              padding: '10px 18px'
            }}
          >
            <div className="d-flex align-items-center gap-2">
              <div 
                className="d-flex align-items-center justify-content-center rounded-circle"
                style={{ width: 30, height: 30, background: 'rgba(239, 68, 68, 0.15)', flexShrink: 0 }}
              >
                <i className="bi bi-file-earmark-pdf-fill text-danger" style={{ fontSize: '0.9rem' }}></i>
              </div>
              <div>
                <Modal.Title style={{ fontSize: '0.9rem', fontWeight: 700, color: '#fff' }}>
                  {pdfTitipTitle || 'Laporan Jurnal Titip Ulang'}
                </Modal.Title>
                <div style={{ fontSize: '0.68rem', color: '#94a3b8' }}>
                  Preview Dokumen PDF SIMRS Bendahara
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center gap-2 ms-auto me-2">
              <Button 
                variant="outline-light" 
                size="sm"
                onClick={() => {
                  const iframe = document.getElementById('iframe-pdf-titip');
                  if (iframe && iframe.contentWindow) {
                    iframe.contentWindow.focus();
                    iframe.contentWindow.print();
                  }
                }}
                style={{ fontSize: '0.75rem', padding: '4px 10px', borderRadius: '5px' }}
                className="d-flex align-items-center gap-1"
              >
                <i className="bi bi-printer"></i>
                <span>Print</span>
              </Button>
              <a 
                href={pdfTitipUrl} 
                download={`${pdfTitipTitle || 'Laporan_Titip_Ulang'}.pdf`}
                className="btn btn-primary btn-sm d-flex align-items-center gap-1"
                style={{ fontSize: '0.75rem', padding: '4px 10px', borderRadius: '5px' }}
              >
                <i className="bi bi-download"></i>
                <span>Unduh</span>
              </a>
            </div>
          </Modal.Header>
          <Modal.Body className="p-0 bg-dark" style={{ height: '80vh' }}>
            {pdfTitipUrl ? (
              <iframe 
                id="iframe-pdf-titip"
                src={pdfTitipUrl} 
                title={pdfTitipTitle} 
                width="100%" 
                height="100%" 
                style={{ border: 'none' }} 
              />
            ) : (
              <div className="d-flex h-100 justify-content-center align-items-center text-white">
                <Spinner animation="border" size="sm" className="me-2" />
                <span>Memuat dokumen PDF...</span>
              </div>
            )}
          </Modal.Body>
        </Modal>

</Card>
      </div>

    </div>
  );
};

export default KasBendahara;
